import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Button, Tooltip, Input, InputNumber, Select, Option, Row, Alert, DatePicker, TimePicker, Loading, Col, Checkbox, CheckboxGroup, Dropdown, DropdownMenu, DropdownItem, Tag, Table, TableColumn, Pagination as Pagination$1, Popover, Radio } from 'element-ui';
import { validationMixin } from 'vuelidate';
import { mask } from 'vue-the-mask';
import { required, email, decimal, alphaNum, alpha, integer, maxValue, minValue, maxLength, minLength } from 'vuelidate/lib/validators';
import { capitalize, get, upperFirst, upperCase, lowerCase, startCase, cloneDeep, has as has$1, range, throttle, truncate, isBoolean, isEmpty, omit, isEqual } from 'lodash';
import { INFSelectField as INFSelectField$1, INFTextField as INFTextField$1 } from '..';
import * as dateFns from 'date-fns';
import { format, getYear, set as set$1 } from 'date-fns';
import { subYears, isToday, isBefore, addMinutes, format as format$1, parseISO, isPast, setSeconds } from 'date-fns/esm';
import { CurrencyInput } from 'vue-currency-input';
import ProdVue from 'vue/dist/vue.esm.js';
import 'element-ui/lib/theme-chalk/reset.css';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import { createNamespacedHelpers } from 'vuex';
import has from 'lodash/has';
import set from 'lodash/set';
import * as qs from 'qs';

// import Vue from "vue";
const install$3 = function installInfVueComponents(Vue) {
  Vue.filter("capitalize", val => capitalize(val));
  Vue.filter("formatDateTime", val => format(new Date(val), "M/d/yyyy h:mm:ss a"));
  Vue.filter("formatDate", val => format(new Date(val), "M/d/yyyy"));
  Vue.filter("formatTime", val => format(new Date(val), "h:mm:ss a"));
  Vue.filter("formatCurrency", num => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(num);
  });
  Vue.filter("formatCurrencyCompact", num => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      notation: "compact",
      compactDisplay: "short"
    }).format(num);
  });
  Vue.filter("formatCurrencyCompactLong", num => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      notation: "compact",
      compactDisplay: "long"
    }).format(num);
  });
};

var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    install: install$3
});

function install$2(Vue, _ref) {
  let {
    strings
  } = _ref;

  Vue.prototype.__getText = function (namespace, stringKey) {
    const getnamespace = namespace ? get(strings, namespace) : strings;
    const getText = get(getnamespace, stringKey);

    if (typeof getText === 'string') {
      return getText;
    } else if (typeof getText === 'function') {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return getText.apply(this, args);
    }

    return "";
  };

  Vue.prototype.__getString = function (namespace, stringKey) {
    const getnamespace = namespace ? get(strings, namespace) : strings;
    const getText = get(getnamespace, stringKey);

    if (Array.isArray(getText)) {
      return getText.join(" ");
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return this.__getText(namespace, stringKey, ...args);
    }
  };

  Vue.prototype.__getTextUcFirst = function (namespace, stringKey) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    const getText = upperFirst(this.__getText(namespace, stringKey, ...args));
    return getText;
  };

  Vue.prototype.__getTextUcEach = function (namespace, stringKey) {
    for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
      args[_key4 - 2] = arguments[_key4];
    }

    const getText = upperCase(this.__getText(namespace, stringKey, ...args));
    return getText;
  };

  Vue.prototype.__getTextLower = function (namespace, stringKey) {
    for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
      args[_key5 - 2] = arguments[_key5];
    }

    const getText = lowerCase(this.__getText(namespace, stringKey, ...args));
    return getText;
  };

  Vue.prototype.__getTextStartCase = function (namespace, stringKey) {
    for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
      args[_key6 - 2] = arguments[_key6];
    }

    const getText = startCase(this.__getText(namespace, stringKey, ...args));
    return getText;
  };
}

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    install: install$2
});

const defaultState = () => {
  return {
    tableRecordsPerPageCount: 0,
    currentPage: 1,
    defaultPageSize: 10,
    totalTableRecords: 0,
    tableData: [],
    tableRowData: {},
    tableRowDataEvent: {},
    tableRowDataColumn: {},
    tableActions: [],
    actionLinks: [],
    paginationPageSizes: [],
    paginationLinks: {
      pages: []
    },
    showAdvancedTableFilter: false,
    showSimpleTableFilter: false,
    tableColumnRules: {},
    //table columns data
    tableColumns: [],
    query: {},
    filterQueryOperations: [],
    filterQuery: {},
    activeFilterQueries: [],
    // used by active fields in advanced filter
    selectedTableColumns: [],
    advanceFilterFields: [],
    simpleFilterFields: [],
    listViewStoreReady: false,
    singleFilter: {}
  };
};
const state = defaultState();

const getters = {
  getTableColumns: state => state.tableColumns,
  getActiveTableColumns: state => state.selectedTableColumns,
  currentPage: state => state.currentPage,
  getQuery: state => state.query,
  paginationPageSizes: state => state.paginationPageSizes,
  defaultPageSize: state => state.defaultPageSize
};

const SET_LIST_VIEW_MODULE_STATE = "SET_LIST_VIEW_MODULE_STATE";
const SET_ACTIVE_TABLE_COLUMNS = "SET_ACTIVE_TABLE_COLUMNS";
const RESET_LIST_VIEW_MODULE_STORE = "RESET_LIST_VIEW_MODULE_STORE";

const mutations = {
  [SET_LIST_VIEW_MODULE_STATE](state, _ref) {
    let {
      key,
      value
    } = _ref;

    if (has(state, key)) {
      set(state, key, value);
    }
  },

  [SET_ACTIVE_TABLE_COLUMNS](state, headers) {
    state.selectedTableColumns = headers;
  },

  [RESET_LIST_VIEW_MODULE_STORE](state) {
    Object.assign(state, defaultState());
  }

};

const actions = {};

const namespaced = true;
const namespace = "list_view_module";
const {
  mapState: listViewModuleMapState,
  mapGetters: listViewModuleMapGetters,
  mapMutations: listViewModuleMapMutations,
  mapActions: listViewModuleMapActions
} = createNamespacedHelpers(namespace);
const list_view_module = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};

const allowedButtonStyles = ["default", "plain", "round", "circle"];
const allowedButtonTypes = ["primary", "success", "info", "warning", "danger", "text"];
const allowedButtonSizes = ["medium", "small", "mini", "large"];
const allowedNativeTypes = ["button", "submit", "reset", "text"];
var script$x = Vue.extend({
  name: "inf-button",
  components: {
    FontAwesomeIcon,
    "el-button": Button
  },
  props: {
    id: {
      //button identifier
      type: String,
      default: function () {
        return Math.random().toString(36).substring(7);
      }
    },
    type: {
      //button type
      type: String,
      default: "primary",
      validator: val => allowedButtonTypes.includes(val)
    },
    buttonStyle: {
      //element-ui button styles
      type: String,
      default: "default",
      validator: val => allowedButtonStyles.includes(val)
    },
    icon: {
      //element-ui icon class name
      type: String,
      default: ""
    },
    faIcon: {
      type: String,
      default: ""
    },
    click: {
      //click event / function
      type: Function,
      default: function () {
        alert("No event attached to this button");
      }
    },
    title: {
      //button title
      type: String,
      default: ""
    },
    loading: {
      //loading
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      //auto-focus button on loaded
      type: Boolean,
      default: false
    },
    nativeType: {
      //html button type attribute
      type: String,
      default: "button",
      validator: val => allowedNativeTypes.includes(val)
    },
    size: {
      //element-ui button size
      type: String,
      default: "medium",
      validator: val => allowedButtonSizes.includes(val)
    },
    blockOnMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isPlain: function () {
      return this.buttonStyle === "plain";
    },
    isRound: function () {
      return this.buttonStyle === "round";
    },
    isCircle: function () {
      return this.buttonStyle === "cirlce";
    },

    additionalClasses() {
      const classes = [];
      const {
        blockOnMobile
      } = this;

      if (blockOnMobile) {
        classes.push('sm:inline block w-full sm:w-auto text-center');
      }

      return classes;
    }

  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$x = script$x;
/* template */

var __vue_render__$v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('el-button', {
    class: _vm.additionalClasses,
    attrs: {
      "id": _vm.id,
      "type": _vm.type,
      "round": _vm.isRound,
      "plain": _vm.isPlain,
      "circle": _vm.isCircle,
      "icon": _vm.icon,
      "loading": _vm.loading,
      "disabled": _vm.disabled,
      "size": _vm.size,
      "autofocus": _vm.autofocus,
      "native-type": _vm.nativeType
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.click();
      }
    }
  }, [_vm.title ? _c('span', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm.faIcon ? _c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', _vm.faIcon]
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$v = [];
/* style */

const __vue_inject_styles__$x = undefined;
/* scoped */

const __vue_scope_id__$x = undefined;
/* module identifier */

const __vue_module_identifier__$x = undefined;
/* functional template */

const __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

var INFButton = __vue_component__$J;

const AllowedValidations$1 = ["custom", "email", "minLength", "maxLength", "minValue", "maxValue", "alpha", "alphaNum", "integer", "decimal", "required"];
var script$w = Vue.extend({
  name: "inf-text-field",
  mixins: [validationMixin],
  components: {
    "el-tooltip": Tooltip,
    "el-input": Input,
    "el-input-number": InputNumber,
    "font-awesome-icon": FontAwesomeIcon
  },
  directives: {
    mask
  },
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    labelIcon: {
      type: String,
      default: ""
    },
    labelIconTooltip: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    rows: {
      type: Number,
      default: 0
    },
    required: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showFieldAs: {
      type: String,
      default: ""
    },
    customValidator: {
      type: Function,
      required: false
    },
    validations: {
      type: Array,
      default: function () {
        return [];
      },

      validator(value) {
        return !value.map(v => AllowedValidations$1.includes(v.method)).includes(false);
      }

    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 500000000
    },
    precision: {
      type: Number,
      default: 0
    },
    controls: {
      type: Boolean,
      default: false
    },
    focusOnMount: {
      type: Boolean,
      default: false
    },
    defaultTaxIdMask: {
      type: String,
      default: "SSN",
      validator: val => {
        return val === "SSN" || val === "EIN";
      }
    },
    fieldGroupClass: {
      type: String,
      default: "pb-12"
    },
    fixedLabels: {
      // for making the labels be fix position rather than animated
      type: Boolean,
      default: false
    },
    formatValueOut: {
      type: Function,
      required: false
    },
    size: {
      type: String,
      required: false,
      default: "medium"
    },
    inputTextClass: {
      type: String,
      default: ""
    },
    showInputLabel: {
      type: Boolean,
      required: false,
      default: true
    },
    labelClass: {
      type: String,
      required: false,
      default: ""
    },
    prefixIcon: {
      type: String,
      required: false,
      default: ""
    },
    suffixIcon: {
      type: String,
      required: false,
      default: ""
    },
    autocomplete: {
      type: String,
      required: false,
      default: "none" // off doesnt work in chrome

    },
    description: {
      type: String,
      required: false,
      default: ""
    },
    descriptionHTML: {
      type: String,
      required: false,
      default: ""
    }
  },

  data() {
    return {
      isFocused: false,
      sample_text: "",
      couldAutoSave: false
    };
  },

  watch: {
    sample_text: function (value) {
      if (this.formatValueOut) {
        const formatedValue = this.formatValueOut(value);
        this.$emit("input", this.formatValueOut ? this.formatValueOut(value) : value);
        this.sample_text = formatedValue;
      } else {
        this.$emit("input", value);
      }
    },
    value: {
      handler: function (value) {
        this.sample_text = value;
      },
      immediate: true
    },
    displayErrorMessage: {
      handler() {
        this.emitErrors();
      },

      immediate: true
    },
    displayIcon: {
      handler() {
        this.emitErrors();
      },

      immediate: true
    }
  },

  mounted() {
    this.sample_text = this.value;
    const field = this.$refs.textField;
    this.$v.$touch();

    if (this.focusOnMount) {
      const el = field.$el.children[0];
      el.focus();
    }
  },

  /* istanbul ignore next */
  validations() {
    const sample_text = this.required ? {
      required
    } : {};
    this.validations.forEach(validation => {
      if (AllowedValidations$1.includes(validation.method)) {
        Object.assign(sample_text, this.getValidationParam(validation));
      }
    });
    return {
      sample_text
    };
  },

  methods: {
    getValidationParam(validation) {
      const val = validation.value;
      let validationParam = {};

      switch (validation.method) {
        case "required":
          validationParam["required"] = required;
          break;

        case "minLength":
          validationParam["minLength"] = minLength(val);
          break;

        case "maxLength":
          validationParam["maxLength"] = maxLength(val);
          break;

        case "minValue":
          validationParam["minValue"] = minValue(val);
          break;

        case "maxValue":
          validationParam["maxValue"] = maxValue(val);
          break;

        case "integer":
          validationParam["integer"] = integer;
          break;

        case "alpha":
          validationParam["alpha"] = alpha;
          break;

        case "alphaNum":
          validationParam["alphaNum"] = alphaNum;
          break;

        case "decimal":
          validationParam["decimal"] = decimal;
          break;

        case "email":
          // @ts-ignore
          validationParam["email"] = value => email((value || "").toLowerCase());

          break;

        case "custom":
          validationParam["custom"] = this.customValidator;
          break;
      }

      return validationParam;
    },

    emitErrors() {
      const errors = cloneDeep(this.displayErrorMessage || []);

      if (this.displayIcon === 'asterisk') {
        errors.push('Field is required');
      }

      this.$emit('validationChanged', errors);
    },

    onEnter() {
      this.$emit("onEnter", this);
    },

    onTab() {
      this.$emit("onTab", this);
    },

    emitChange(v) {
      if (typeof v === "object") {
        if (v.target && v.target.value) {
          this.$emit("change", v.target.value);
        }
      } else {
        this.$emit("change", v);
      }
    },

    focusField() {
      this.$emit("focus");
      this.isFocused = true;
      this.$emit('focusField');
    },

    blurField() {
      this.$emit("blur", this.sample_text);
      this.isFocused = false;
      this.$emit('blurField');
    },

    maybeFocusField() {
      if (!this.isFocused || !this.sample_text) {
        this.focusField();
        this.$nextTick(this.focusFieldRef);
      }
    },

    focusFieldRef() {
      const field = this.$refs.textField;
      const inputField = field.$el.querySelector("input");

      if (inputField) {
        inputField.focus();
      }
    }

  },
  computed: {
    displayErrorMessage() {
      const messages = [];
      const validations = cloneDeep(this.validations);
      const defaultMessages = {
        email: () => "Invalid email address",
        required: () => "Text Field is required",
        minLength: val => `Minimum length is ${val}`,
        maxLength: val => `Maximum length is ${val}`,
        minValue: val => `Minimum Value is ${val}`,
        maxValue: val => `Maximum Value is ${val}`,
        alpha: () => "Only alphabetical characters are allowed",
        alphaNum: () => "Only alpha numerics are allowed",
        decimal: () => "Only decimals",
        integer: () => "Only Integers",
        custom: () => "Error"
      };
      validations.forEach(validation => {
        const value = validation.value;
        const method = validation.method;
        const message = validation.error ? validation.error : defaultMessages[method](value);

        if (!this.$v.sample_text[method]) {
          messages.push(message);
        }
      });
      return messages;
    },

    displayIcon: function () {
      if (this.loading) {
        return "spinner";
      }

      if (has$1(this.$v.sample_text, "required") && !this.$v.sample_text.required) {
        return "asterisk";
      }

      if (!this.$v.$error && !this.$v.$invalid) {
        if (!this.sample_text && !has$1(this.$v.sample_text, "required")) {
          return "";
        }

        return "check";
      }

      if (this.$v.$error || this.$v.$invalid) {
        return "times";
      }

      return "";
    },

    isFocusedOrHasValue() {
      return !!this.sample_text || this.isFocused;
    },

    getTaxIdMaskingFormat: function () {
      return this.defaultTaxIdMask === "SSN" ? "###-##-####" : "##-#######";
    }
  }
});

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$w = script$w;
/* template */

var __vue_render__$u = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "form-group",
    class: (_obj = {
      hasError: _vm.$v.$error,
      isFocus: _vm.isFocused,
      hasValue: _vm.sample_text && _vm.sample_text !== '',
      fixedLabels: _vm.fixedLabels
    }, _obj[_vm.fieldGroupClass] = true, _obj)
  }, [_c('div', {
    staticClass: "form-field",
    class: "form-field-" + _vm.type + " form-field-" + (_vm.showFieldAs ? _vm.showFieldAs : 'normal')
  }, [_vm.labelIcon ? _c(_vm.labelIconTooltip ? 'el-tooltip' : 'div', {
    tag: "component",
    staticClass: "absolute -top-5 right-2 text-yellow-600",
    attrs: {
      "tabindex": 9999,
      "disabled": _vm.loading,
      "content": _vm.labelIconTooltip,
      "placement": "top"
    }
  }, [_c('div', {
    on: {
      "click": function ($event) {
        return _vm.$emit('clickFieldArea', 'label-icon');
      }
    }
  }, [_vm.labelIcon === 'info' ? _c('svg', {
    staticClass: "h-4 w-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
      "clip-rule": "evenodd"
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm.showInputLabel ? _c('label', {
    class: _vm.labelClass,
    on: {
      "click": function ($event) {
        _vm.$emit('clickFieldArea', 'label');

        _vm.maybeFocusField();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.type === 'number' ? _c('el-input-number', {
    ref: "textField",
    staticClass: "w-full",
    class: _vm.inputTextClass,
    attrs: {
      "min": _vm.min,
      "max": _vm.max,
      "controls": _vm.controls,
      "size": _vm.size,
      "placeholder": !_vm.label || _vm.isFocused ? _vm.placeholder : "",
      "autocomplete": _vm.autocomplete,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "precision": _vm.precision
    },
    on: {
      "input": function ($event) {
        return _vm.$v.$touch();
      },
      "change": _vm.emitChange,
      "focus": _vm.focusField,
      "blur": _vm.blurField
    },
    nativeOn: {
      "focus": function ($event) {
        return _vm.focusField.apply(null, arguments);
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.onEnter.apply(null, arguments);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }

        return _vm.onTab.apply(null, arguments);
      }
    },
    model: {
      value: _vm.sample_text,
      callback: function ($$v) {
        _vm.sample_text = $$v;
      },
      expression: "sample_text"
    }
  }) : _vm.type === 'phone' ? _c('el-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###-###-####',
      expression: "'###-###-####'"
    }],
    ref: "textField",
    attrs: {
      "type": _vm.type,
      "placeholder": !_vm.label || _vm.isFocused ? _vm.placeholder : "",
      "autocomplete": _vm.autocomplete,
      "masked": true,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "rows": _vm.type == 'textarea' ? _vm.rows : '',
      "prefix-icon": _vm.prefixIcon,
      "suffix-icon": _vm.suffixIcon
    },
    on: {
      "input": function ($event) {
        return _vm.$v.$touch();
      },
      "change": _vm.emitChange,
      "focus": _vm.focusField,
      "blur": _vm.blurField
    },
    nativeOn: {
      "focus": function ($event) {
        return _vm.focusField.apply(null, arguments);
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.onEnter.apply(null, arguments);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }

        return _vm.onTab.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([_vm._l(_vm.$slots, function (index, name) {
      return {
        key: name,
        fn: function () {
          return [_vm._t(name)];
        },
        proxy: true
      };
    })], null, true),
    model: {
      value: _vm.sample_text,
      callback: function ($$v) {
        _vm.sample_text = $$v;
      },
      expression: "sample_text"
    }
  }) : _vm.type === 'taxId' ? _c('el-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.getTaxIdMaskingFormat,
      expression: "getTaxIdMaskingFormat"
    }],
    ref: "textField",
    attrs: {
      "type": 'text',
      "placeholder": !_vm.label || _vm.isFocused ? _vm.placeholder : "",
      "autocomplete": _vm.autocomplete,
      "masked": true,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "rows": _vm.type == 'textarea' ? _vm.rows : '',
      "autofocus": _vm.focusOnMount,
      "prefix-icon": _vm.prefixIcon,
      "suffix-icon": _vm.suffixIcon
    },
    on: {
      "input": function ($event) {
        return _vm.$v.$touch();
      },
      "change": _vm.emitChange,
      "focus": _vm.focusField,
      "blur": _vm.blurField
    },
    nativeOn: {
      "focus": function ($event) {
        return _vm.focusField.apply(null, arguments);
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.onEnter.apply(null, arguments);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }

        return _vm.onTab.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([_vm._l(_vm.$slots, function (index, name) {
      return {
        key: name,
        fn: function () {
          return [_vm._t(name)];
        },
        proxy: true
      };
    })], null, true),
    model: {
      value: _vm.sample_text,
      callback: function ($$v) {
        _vm.sample_text = $$v;
      },
      expression: "sample_text"
    }
  }) : _c('el-input', {
    ref: "textField",
    class: _vm.inputTextClass,
    attrs: {
      "type": _vm.type,
      "placeholder": !_vm.label || _vm.isFocused ? _vm.placeholder : "",
      "autocomplete": _vm.autocomplete,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "rows": _vm.type == 'textarea' ? _vm.rows : '',
      "size": _vm.size,
      "prefix-icon": _vm.prefixIcon,
      "suffix-icon": _vm.suffixIcon
    },
    on: {
      "input": function ($event) {
        return _vm.$v.$touch();
      },
      "focus": _vm.focusField,
      "blur": _vm.blurField
    },
    nativeOn: {
      "change": function ($event) {
        return _vm.emitChange.apply(null, arguments);
      },
      "focus": function ($event) {
        return _vm.focusField.apply(null, arguments);
      },
      "blur": function ($event) {
        return _vm.blurField.apply(null, arguments);
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.onEnter.apply(null, arguments);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }

        return _vm.onTab.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([_vm._l(_vm.$slots, function (index, name) {
      return {
        key: name,
        fn: function () {
          return [_vm._t(name)];
        },
        proxy: true
      };
    })], null, true),
    model: {
      value: _vm.sample_text,
      callback: function ($$v) {
        _vm.sample_text = $$v;
      },
      expression: "sample_text"
    }
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "tabindex": 9999,
      "disabled": _vm.$v.sample_text.required && _vm.$v.sample_text.required === true,
      "content": _vm.loading ? "Loading" : "Required",
      "placement": "top"
    }
  }, [_vm.displayIcon ? _c('span', {
    staticClass: "icon",
    class: "icon-" + _vm.displayIcon + ' ' + "" + (_vm.loading ? 'fa-spin' : ''),
    attrs: {
      "tabindex": 9999
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fas', _vm.displayIcon]
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _vm.description ? _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "1px 0 0 2px"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('clickFieldArea', 'description');
      }
    }
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._v(" "), _vm.descriptionHTML ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.descriptionHTML)
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('clickFieldArea', 'description');
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.displayErrorMessage && _vm.displayErrorMessage.length && !_vm.isFocused ? _c('div', {
    staticClass: "error-message flex flex-col w-full p-2 ",
    on: {
      "click": function ($event) {
        return _vm.$emit('clickFieldArea', 'error');
      }
    }
  }, [_c('ul', {
    staticClass: "p-0 list-disc"
  }, _vm._l(_vm.displayErrorMessage, function (err, index) {
    return _c('li', {
      key: index,
      staticClass: "break-words"
    }, [_vm._v(_vm._s(err))]);
  }), 0)]) : _vm._e()]);
};

var __vue_staticRenderFns__$u = [];
/* style */

const __vue_inject_styles__$w = function (inject) {
  if (!inject) return;
  inject("data-v-6cb2475a_0", {
    source: ".table-filter-fields .form-group[data-v-6cb2475a]{padding:0}.form-field[data-v-6cb2475a]{position:relative}.form-field label[data-v-6cb2475a]{position:absolute;top:12px;left:12px;font-size:14px;z-index:1;transition:all ease-in-out .24s;line-height:1.2}.form-field-p label[data-v-6cb2475a]{left:2px}.form-field-h1 input[data-v-6cb2475a],.form-field-h1 label[data-v-6cb2475a]{font-size:36px;height:40px!important}.hasValue .form-field label[data-v-6cb2475a],.isFocus .form-field label[data-v-6cb2475a]{top:-18px;left:2px;font-size:14px}.hasValue .form-field-p label[data-v-6cb2475a],.isFocus .form-field-p label[data-v-6cb2475a]{bottom:-5px;top:auto;left:2px;font-size:11px;opacity:.7}.fixedLabels .form-field label[data-v-6cb2475a]{top:-18px;left:2px;font-size:14px}.form-field.form-field-h1 input[data-v-6cb2475a],.form-field.form-field-h1 label[data-v-6cb2475a]{font-size:36px!important;height:48px!important;line-height:48px!important}.form-field.form-field-h1 label[data-v-6cb2475a]{top:0;left:0}.hasValue .form-field.form-field-h1 label[data-v-6cb2475a],.isFocus .form-field.form-field-h1 label[data-v-6cb2475a]{display:none}.error-message[data-v-6cb2475a]{color:#ef4444;font-weight:600;font-size:12px}.form-field .icon[data-v-6cb2475a]{position:absolute;z-index:9;right:13px;bottom:12px;background:inherit;width:12px}.form-field-p .icon[data-v-6cb2475a]{left:-19px;right:auto}.form-field .icon svg[data-v-6cb2475a]{width:12px}.field-right[data-v-6cb2475a]{float:right}.icon-asterisk[data-v-6cb2475a],.icon-times[data-v-6cb2475a]{color:#ef4444}.isFocus .icon-asterisk[data-v-6cb2475a],.isFocus .icon-times[data-v-6cb2475a]{color:#fca5a5}.icon-check[data-v-6cb2475a]{color:#34d399}.form-field-h1 .icon[data-v-6cb2475a]{right:auto;left:-21px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$w = "data-v-6cb2475a";
/* module identifier */

const __vue_module_identifier__$w = undefined;
/* functional template */

const __vue_is_functional_template__$w = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, createInjector, undefined, undefined);

var INFTextField = __vue_component__$I;

const AllowedValidations = ["custom", "required"];
var script$v = Vue.extend({
  name: "INFSelectField",
  mixins: [validationMixin],
  components: {
    "el-select": Select,
    "el-option": Option,
    "el-tooltip": Tooltip,
    "font-awesome-icon": FontAwesomeIcon
  },
  props: {
    showInputLabel: {
      type: Boolean,
      required: false,
      default: true
    },
    labelClass: {
      type: String,
      required: false,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Select"
    },
    selected: {
      type: [Number, String, Array, Boolean],
      default: ""
    },
    options: {
      type: Array,
      required: true,

      default() {
        return [];
      }

    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelKey: {
      type: [String, Array],
      default: "label"
    },
    valueKey: {
      type: String,
      default: "value"
    },
    showFieldAs: {
      type: String,
      default: ""
    },
    remote: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    remoteMethod: {
      type: Function,
      default: () => {}
    },
    fieldGroupClass: {
      type: String,
      default: "pb-12"
    },
    optionComponent: {
      type: Function,
      required: false
    },
    optionHeight: {
      type: String,
      required: false,
      default: "34px"
    },
    size: {
      type: String,
      required: false
    },
    disabledOptions: {
      type: Array,
      required: false,
      default: () => []
    },
    allowCreate: {
      type: Boolean,
      required: false,
      default: false
    },
    selectFieldClass: {
      type: String,
      required: false,
      default: ""
    },
    allowFirstOption: {
      type: Boolean,
      required: false,
      default: false
    },
    fixedLabels: {
      type: Boolean,
      required: false,
      default: false
    },
    popperClass: {
      type: String,
      required: false,
      default: ""
    },
    customValidator: {
      type: Function,
      required: false
    },
    validations: {
      type: Array,
      default: function () {
        return [];
      },

      validator(value) {
        return !value.map(v => AllowedValidations.includes(v.method)).includes(false);
      }

    }
  },
  watch: {
    selected: {
      handler: function (selected) {
        this.sample_text = selected;
        this.$v.$touch();
      },
      immediate: true
    },
    hasError: {
      handler(value) {
        this.$emit('validationChanged', value ? this.displayErrorMessage : []);
      },

      immediate: true
    }
  },

  data() {
    return {
      sample_text: "",
      isFocused: false,
      isMouseOver: false
    };
  },

  methods: {
    getValidationParam(validation) {
      let validationParam = {};

      switch (validation.method) {
        case "custom":
          validationParam["custom"] = this.customValidator;
          break;

        case "required":
          validationParam["required"] = required;
          break;
      }

      return validationParam;
    },

    onEnter() {
      this.$emit("onEnter");
    },

    emitChange(v) {
      this.$emit("change", v);
    },

    onClearField() {
      this.$emit("clear");
      this.blurField();
      this.blurFieldHover();
    },

    focusField() {
      this.isFocused = true; // if selected is already set, set hoverIndex to the selected option

      if (this.selected) {
        const {
          selectField
        } = this.$refs;
        const index = this.options.findIndex(option => {
          return option.value === selectField.value;
        });
        selectField.$data.hoverIndex = index;
      }
    },

    blurField() {
      this.isFocused = false;
    },

    visibleChangeHover() {
      const {
        selectField
      } = this.$refs;

      if (selectField && selectField.$data && typeof selectField.$data.hoverIndex === 'number' && selectField.$data.hoverIndex !== -1) {
        const {
          selected,
          hoverOption
        } = selectField.$data;
        const options = this.options;
        const value = get(options, `${selectField.$data.hoverIndex}.value`, undefined);

        if (typeof value !== 'undefined') {
          let newValue;

          if (this.multiple) {
            if (selected.find(select => select.currentValue === hoverOption.currentValue)) return;
            newValue = [...new Set([...this.sample_text, value])];
          } else {
            if (selected.currentValue === hoverOption.currentValue) return;
            newValue = value;
          }

          this.emitChange(newValue);
        }
      }

      this.isFocused = false;
    },

    focusFieldHover() {
      this.isMouseOver = true;
    },

    blurFieldHover() {
      this.isMouseOver = false;
    },

    maybeFocusField() {
      if (!this.isFocused || typeof this.sample_text === "undefined" || this.sample_text === "") {
        this.focusField();
        this.$nextTick(this.focusFieldRef);
      }
    },

    focusFieldRef() {
      try {
        const field = this.$refs.selectField;
        const inputField = field.$el.querySelector("select"); // const field = fieldRef.$el;

        if (inputField) {
          inputField.focus();
          inputField.click();
        }
      } catch (error) {
        /* Do Nothing */
      }
    }

  },

  validations() {
    const sample_text = this.required ? {
      required
    } : {};
    this.validations.forEach(validation => {
      if (AllowedValidations.includes(validation.method)) {
        Object.assign(sample_text, this.getValidationParam(validation));
      }
    });
    return {
      sample_text
    };
  },

  computed: {
    displayErrorMessage() {
      const messages = [];
      const validations = cloneDeep(this.validations);
      const defaultMessages = {
        custom: () => "Error",
        required: () => "Field is required"
      };
      validations.forEach(validation => {
        const value = validation.value;
        const method = validation.method;
        const message = validation.error ? validation.error : defaultMessages[method](value);

        if (!this.$v.sample_text[method]) {
          messages.push(message);
        }
      });
      return messages;
    },

    hasError: function () {
      return !!this.displayErrorMessage.length;
    },
    displayIcon: function () {
      if (this.loading) {
        return "spinner";
      }

      if (has$1(this.$v.sample_text, "required") && !this.$v.sample_text.required) {
        return "asterisk";
      }

      if (typeof this.sample_text === "number") {
        return "check";
      }

      if (this.sample_text && this.sample_text.length > 0) {
        return "check";
      }

      if (!this.$v.$error && !this.$v.$invalid) {
        if (!this.sample_text && !has$1(this.$v.sample_text, "required")) {
          return "";
        }

        return "check";
      }

      if (this.$v.$error || this.$v.$invalid) {
        return "times";
      }

      return "asterisk";
    }
  },

  mounted() {
    this.$v.$touch();
  }

});

/* script */
const __vue_script__$v = script$v;
/* template */

var __vue_render__$t = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "form-group",
    class: (_obj = {
      hasError: _vm.hasError,
      isFocus: _vm.isFocused || _vm.isMouseOver,
      hasValue: typeof _vm.selected !== 'undefined' && _vm.selected !== '',
      fixedLabels: _vm.fixedLabels
    }, _obj[_vm.fieldGroupClass] = true, _obj)
  }, [_c('div', {
    staticClass: "form-field",
    class: "form-field-" + (_vm.showFieldAs ? _vm.showFieldAs : 'normal')
  }, [_vm.showInputLabel ? _c('label', {
    class: _vm.labelClass,
    on: {
      "click": _vm.maybeFocusField
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('el-select', {
    ref: "selectField",
    class: _vm.selectFieldClass,
    attrs: {
      "multiple": _vm.multiple,
      "allow-create": _vm.allowCreate,
      "clearable": _vm.clearable,
      "placeholder": _vm.isFocused || !_vm.label ? _vm.placeholder : "",
      "autocomplete": "none",
      "disabled": _vm.disabled,
      "filterable": _vm.filterable,
      "remote": _vm.remote,
      "remote-method": _vm.remoteMethod,
      "size": _vm.size,
      "default-first-option": _vm.allowFirstOption,
      "popper-class": _vm.popperClass,
      "automatic-dropdown": false
    },
    on: {
      "change": _vm.emitChange,
      "focus": _vm.focusField,
      "blur": _vm.blurFieldHover,
      "clear": _vm.onClearField
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.onEnter.apply(null, arguments);
      },
      "mouseenter": function ($event) {
        return _vm.focusFieldHover.apply(null, arguments);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 9) {
          return null;
        }

        return _vm.visibleChangeHover.apply(null, arguments);
      },
      "mouseleave": function ($event) {
        return _vm.blurFieldHover.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([_vm._l(_vm.$slots, function (index, name) {
      return {
        key: name,
        fn: function () {
          return [_vm._t(name)];
        },
        proxy: true
      };
    })], null, true),
    model: {
      value: _vm.sample_text,
      callback: function ($$v) {
        _vm.sample_text = $$v;
      },
      expression: "sample_text"
    }
  }, _vm._l(_vm.options, function (item, index) {
    return _c('el-option', {
      key: item.value + "-" + index,
      style: "height:" + _vm.optionHeight,
      attrs: {
        "label": Array.isArray(_vm.labelKey) ? _vm.labelKey.map(function (k) {
          return item[k];
        }).join(' - ') : item[_vm.labelKey],
        "value": item[_vm.valueKey],
        "selected": _vm.selected === item[_vm.valueKey],
        "disabled": _vm.disabledOptions.includes(item[_vm.valueKey])
      }
    }, [_vm.optionComponent ? _c('div', [_c(_vm.optionComponent(), {
      tag: "component",
      attrs: {
        "item": item
      }
    })], 1) : _c('div', [_vm._v(_vm._s(item[_vm.labelKey]))])]);
  }), 1), _vm._v(" "), _vm.displayIcon ? _c('el-tooltip', {
    staticClass: "bg-transparent",
    attrs: {
      "tabindex": 9999,
      "disabled": _vm.required,
      "content": "Required",
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "icon",
    class: "icon-" + _vm.displayIcon,
    attrs: {
      "tabindex": 9999
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fas', _vm.displayIcon]
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _vm.displayErrorMessage && _vm.displayErrorMessage.length ? _c('div', {
    staticClass: "error-message flex flex-col w-full p-2 ",
    on: {
      "click": function ($event) {
        return _vm.$emit('clickFieldArea', 'error');
      }
    }
  }, [_c('ul', {
    staticClass: "p-0 list-disc"
  }, _vm._l(_vm.displayErrorMessage, function (err, index) {
    return _c('li', {
      key: index,
      staticClass: "break-words"
    }, [_vm._v(_vm._s(err))]);
  }), 0)]) : _vm._e()]);
};

var __vue_staticRenderFns__$t = [];
/* style */

const __vue_inject_styles__$v = function (inject) {
  if (!inject) return;
  inject("data-v-0910592a_0", {
    source: ".table-filter-fields .form-group[data-v-0910592a]{padding:0}.form-field[data-v-0910592a]{position:relative}.form-field label[data-v-0910592a]{position:absolute;top:12px;left:12px;font-size:14px;z-index:1;transition:all ease-in-out .24s;line-height:1.2}.form-field-p label[data-v-0910592a]{left:2px}.form-field.form-field-switch label[data-v-0910592a],.hasValue .form-field label[data-v-0910592a],.isFocus .form-field label[data-v-0910592a],label[data-v-0910592a]{top:-24px;left:2px;font-size:14px!important}.form-field-p.form-field-switch label[data-v-0910592a],.hasValue .form-field-p label[data-v-0910592a],.isFocus .form-field-p label[data-v-0910592a]{bottom:-5px;top:auto;left:2px;font-size:11px}.fixedLabels .form-field label[data-v-0910592a]{top:-24px;left:2px;font-size:14px!important}.form-field-h1 input[data-v-0910592a],.form-field-h2 input[data-v-0910592a],.form-field-p input[data-v-0910592a]{border:none}.form-field-h1 input[data-v-0910592a]{font-size:30px}.isFocus .form-field-h1 input[data-v-0910592a],.isFocus .form-field-h2 input[data-v-0910592a],.isFocus .form-field-p input[data-v-0910592a]{border:1px solid #dcdfe6}.error-message[data-v-0910592a]{color:#ef4444;font-weight:600;font-size:12px;line-height:1;margin:4px 0 0 3px;position:absolute}.form-field .icon[data-v-0910592a]{position:absolute;z-index:9;right:13px;bottom:12px;background:#fff;width:12px}.form-field-p .icon[data-v-0910592a]{left:-19px;right:auto;background:0 0}.isFocus .form-field .icon[data-v-0910592a]{display:none}.isFocus .form-field-p .icon[data-v-0910592a]{display:block}.form-field .icon svg[data-v-0910592a]{width:12px}.field-right[data-v-0910592a]{float:right}.icon-asterisk[data-v-0910592a],.icon-times[data-v-0910592a]{color:#ef4444}.isFocus .icon-asterisk[data-v-0910592a],.isFocus .icon-times[data-v-0910592a]{color:#fca5a5}.icon-check[data-v-0910592a]{color:#34d399}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$v = "data-v-0910592a";
/* module identifier */

const __vue_module_identifier__$v = undefined;
/* functional template */

const __vue_is_functional_template__$v = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, createInjector, undefined, undefined);

var INFSelectField = __vue_component__$H;

const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const monthOptions = months.map((item, index) => ({
  value: index,
  label: item
}));
const getDayOptions = daysInMonth => {
  const options = [];

  for (let day = 1; day <= daysInMonth; day++) {
    options.push({
      label: day.toString(),
      value: day
    });
  }

  return options;
};
const thisYear = new Date().getFullYear();
range(thisYear - 10, thisYear + 1).map(item => ({
  value: item,
  label: item
}));
const yearOptions = (minDate, maxDate) => {
  minDate = new Date(minDate);
  maxDate = new Date(maxDate);
  const min = minDate ? getYear(minDate) : 1941;
  const max = (maxDate ? getYear(maxDate) : thisYear) + 1;
  return range(min, max).map(item => ({
    value: item,
    label: item.toString()
  }));
};

var script$u = Vue.extend({
  name: "CustomDatePicker",
  components: {
    INFSelectField: INFSelectField$1
  },
  props: {
    value: {
      type: [String, Date],
      required: false,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    labelClass: {
      default: "",
      type: String
    },
    allowFirstOption: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: "Select Date"
    },
    size: {
      type: String,
      required: false,
      default: "large"
    },
    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },
    minYear: {
      type: [Date, String],
      default: () => {
        return subYears(new Date(), 100);
      }
    },
    maxYear: {
      type: [Date, String],
      default: () => {
        return subYears(new Date(), 18);
      }
    }
  },

  mounted() {
    if (this.value) {
      const date = new Date(this.value);

      if (!isNaN(date.getTime())) {
        this.month = date.getMonth();
        this.day = date.getDate();
        this.year = date.getFullYear();
      }
    }
  },

  data() {
    return {
      monthOptions,
      day: null,
      year: null,
      month: null
    };
  },

  methods: {
    updateDate() {
      if (!dateFns.isSameDay(dateFns.parseISO(this.value), this.getDate()) && typeof this.year === "number" && typeof this.day === "number" && typeof this.month === "number") {
        this.$emit("change", this.getDate());
      }
    },

    getDate() {
      return new Date(this.year, this.month, this.day);
    },

    handleMonthChange(month) {
      const daysInMonth = dateFns.getDaysInMonth(new Date(this.year, month, 1));

      if (daysInMonth < this.day) {
        this.day = daysInMonth;
      }

      this.month = month;
      this.updateDate();
    },

    handleYearChange(year) {
      this.year = year;
      this.updateDate();
    },

    handleDayChange(day) {
      this.day = day;
      this.updateDate();
    }

  },
  computed: {
    dayOptions() {
      const daysInMonth = dateFns.getDaysInMonth(this.getDate());
      return getDayOptions(daysInMonth);
    },

    yearOptions() {
      return yearOptions(this.minYear, this.maxYear);
    }

  }
});

/* script */
const __vue_script__$u = script$u;
/* template */

var __vue_render__$s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "form-group pb-12"
  }, [_c('div', {
    staticClass: "form-field form-field-primary form-field-normal"
  }, [_c('label', {
    staticClass: "absolute -top-5",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('INFSelectField', {
    staticClass: "mr-1 i-custom-date-picker__item",
    attrs: {
      "label": "",
      "options": _vm.monthOptions,
      "selected": _vm.month,
      "required": _vm.required,
      "allowFirstOption": _vm.allowFirstOption,
      "placeholder": "Month",
      "filterable": true,
      "size": _vm.size
    },
    on: {
      "change": _vm.handleMonthChange
    }
  }), _vm._v(" "), _c('INFSelectField', {
    staticClass: "mr-1 day i-custom-date-picker__item",
    attrs: {
      "label": "",
      "options": _vm.dayOptions,
      "selected": _vm.day,
      "required": _vm.required,
      "allowFirstOption": _vm.allowFirstOption,
      "placeholder": "Day",
      "filterable": true,
      "size": _vm.size
    },
    on: {
      "change": _vm.handleDayChange
    }
  }), _vm._v(" "), _c('INFSelectField', {
    staticClass: "year i-custom-date-picker__item",
    attrs: {
      "label": "",
      "options": _vm.yearOptions,
      "selected": _vm.year,
      "required": _vm.required,
      "allowFirstOption": _vm.allowFirstOption,
      "placeholder": "Year",
      "filterable": true,
      "size": _vm.size
    },
    on: {
      "change": _vm.handleYearChange
    }
  })], 1)])]);
};

var __vue_staticRenderFns__$s = [];
/* style */

const __vue_inject_styles__$u = function (inject) {
  if (!inject) return;
  inject("data-v-414ebeda_0", {
    source: ".form-field[data-v-414ebeda]{position:relative}.form-field label[data-v-414ebeda]{font-size:14px;z-index:1;transition:all ease-in-out .24s;line-height:1.2}.fixedLabels .form-field label[data-v-414ebeda]{font-size:11px}.day[data-v-414ebeda]{max-width:5rem}.year[data-v-414ebeda]{max-width:7rem}.i-custom-date-picker[data-v-414ebeda]{display:flex;flex-direction:row}.i-custom-date-picker__item+.i-custom-date-picker__item[data-v-414ebeda]{margin-left:10px}.i-custom-date-picker__label[data-v-414ebeda]{font-size:11px;display:inline-block}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$u = "data-v-414ebeda";
/* module identifier */

const __vue_module_identifier__$u = undefined;
/* functional template */

const __vue_is_functional_template__$u = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, createInjector, undefined, undefined);

var __vue_component__$G = __vue_component__$F;

var script$t = Vue.extend({
  name: "INFPageMessage",
  components: {
    "el-row": Row,
    "el-alert": Alert
  },
  props: {
    type: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    closable: {
      type: Boolean,
      default: true
    },
    effect: {
      type: String,
      required: false,
      default: "light"
    }
  },

  data() {
    return {
      removeTimer: null
    };
  },

  watch: {
    message() {
      if (this.removeTimer) {
        clearTimeout(this.removeTimer);
      }

      this.removeTimer = setTimeout(() => this.close(), 3200);
    }

  },
  methods: {
    close() {
      this.$emit("close");

      if (this.removeTimer) {
        clearTimeout(this.removeTimer);
      }
    }

  },
  computed: {}
});

/* script */
const __vue_script__$t = script$t;
/* template */

var __vue_render__$r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.message ? _c('el-row', {
    staticClass: "page-error-messages z-20",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.message,
      "type": _vm.type,
      "closable": _vm.closable,
      "effect": _vm.effect
    },
    on: {
      "close": _vm.close
    }
  })], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__$r = [];
/* style */

const __vue_inject_styles__$t = function (inject) {
  if (!inject) return;
  inject("data-v-5fa0826b_0", {
    source: ".slide-enter-active{animation:slide-in .3s}.slide-leave-active{animation:slide-in .1s reverse}@keyframes slide-in{0%{transform:scale(.6) translateY(30%)}100%{transform:scale(1) translateY(0)}}.page-error-messages{position:absolute;top:0;left:0;width:100%;height:48px;word-break:break-all}.page-error-messages .el-alert{border-radius:0;background:#fff;color:#333}.page-error-messages .el-alert.el-alert--success{background:#68d391;color:#f0fff4}.page-error-messages .el-alert.el-alert--error{background:#f56565;color:#edf2f7}.page-error-messages .el-alert.el-alert--info{background:#909399;color:#edf2f7}.page-error-messages .el-alert.el-alert--warning{background:#e6a23c;color:#edf2f7}.page-error-messages .el-alert__closebtn{top:19px;right:41px}.page-error-messages .el-alert.el-alert--error .el-alert__closebtn{color:#feb2b2}.page-error-messages .el-alert.el-alert--success .el-alert__closebtn{color:#f0fff4}.page-error-messages.fade-enter-active{transition:top .3s cubic-bezier(.17,.04,.03,.94)}.page-error-messages.fade-leave-active{transition:top 220ms cubic-bezier(.17,.04,.03,.94)}.page-error-messages.fade-enter,.page-error-messages.fade-leave-to{top:-48px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$t = undefined;
/* module identifier */

const __vue_module_identifier__$t = undefined;
/* functional template */

const __vue_is_functional_template__$t = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, createInjector, undefined, undefined);

var __vue_component__$E = __vue_component__$D;

var script$s = Vue.extend({
  name: "INFPageButton"
});

/* script */
const __vue_script__$s = script$s;
/* template */

var __vue_render__$q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "page-button",
    attrs: {
      "id": "app-top-wrapper"
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$q = [];
/* style */

const __vue_inject_styles__$s = function (inject) {
  if (!inject) return;
  inject("data-v-74ca286b_0", {
    source: ".page-button{display:flex;flex-direction:row;z-index:10;justify-content:flex-end;align-items:center;width:100%;background-color:#fff;padding:2.5rem;height:1.5rem;position:fixed;bottom:0;right:0}#app-top-wrapper{width:calc(100% - 80px);transition:width .16s}.isExpanded #app-top-wrapper{width:calc(100% - 240px)}@media only screen and (max-width:780px){#app-top-wrapper{width:100%}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$s = undefined;
/* module identifier */

const __vue_module_identifier__$s = undefined;
/* functional template */

const __vue_is_functional_template__$s = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, createInjector, undefined, undefined);

var __vue_component__$C = __vue_component__$B;

var script$r = Vue.extend({
  name: "INFContentCard",
  props: {
    bodyClasses: {
      type: String
    },
    footerClasses: {
      type: String
    },
    headerClasses: {
      type: String
    },
    tileBackgroundClass: {
      type: String,
      default: "bg-white"
    }
  },
  methods: {
    hasSlot(name) {
      return !!this.$slots[name];
    }

  }
});

/* script */
const __vue_script__$r = script$r;
/* template */

var __vue_render__$p = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "ui-tile shadow",
    class: (_obj = {}, _obj[_vm.tileBackgroundClass] = true, _obj)
  }, [_vm.hasSlot("header") ? _c('div', {
    class: _vm.headerClasses ? _vm.headerClasses : 'header'
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.bodyClasses ? _vm.bodyClasses : 'body'
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.hasSlot("footer") ? _c('div', {
    class: _vm.footerClasses ? _vm.footerClasses : 'footer'
  }, [_vm._t("footer")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__$p = [];
/* style */

const __vue_inject_styles__$r = function (inject) {
  if (!inject) return;
  inject("data-v-5b2de692_0", {
    source: "*{--tw-shadow:0 0 #0000}.shadow{--tw-shadow:0 1px 3px 0 rgba(0, 0, 0, 0.1),0 1px 2px 0 rgba(0, 0, 0, 0.06);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.ui-tile{display:flex;flex-direction:column;justify-content:between}.header{padding:1.2rem;border-color:#dcdcdc;border-bottom-width:1px;border-bottom-style:solid}.body{flex-grow:1;padding:1.2rem}.footer{padding-top:1.2rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$r = undefined;
/* module identifier */

const __vue_module_identifier__$r = undefined;
/* functional template */

const __vue_is_functional_template__$r = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, createInjector, undefined, undefined);

var __vue_component__$A = __vue_component__$z;

const BACKSPACE_KEY = 8;
const LEFT_ARROW_KEY = 37;
const UP_ARROW_KEY = 38;
const RIGHT_ARROW_KEY = 39;
const DOWN_ARROW_KEY = 40;
var script$q = Vue.extend({
  name: "INFAuthCodeInput",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    const nextField = this.$refs[`input1`];

    if (nextField) {
      nextField.focus();
    }
  },

  data() {
    return {
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      input5: "",
      input6: ""
    };
  },

  watch: {
    verifyCode(v) {
      this.$emit("input", v);

      if (v.length === 6) {
        this.$emit("hasFullCode", v);
      }
    }

  },
  methods: {
    getFieldNumber(field) {
      const {
        name
      } = field;
      const [fieldNum] = name.match(/\d+/g).map(Number);
      return fieldNum;
    },

    setField(fieldNum, val) {
      switch (fieldNum) {
        case 1:
          this.input1 = val;
          break;

        case 2:
          this.input2 = val;
          break;

        case 3:
          this.input3 = val;
          break;

        case 4:
          this.input4 = val;
          break;

        case 5:
          this.input5 = val;
          break;

        case 6:
          this.input6 = val;
          break;
      }
    },

    getField(fieldNum) {
      switch (fieldNum) {
        case 1:
          return this.input1;

        case 2:
          return this.input2;

        case 3:
          return this.input3;

        case 4:
          return this.input4;

        case 5:
          return this.input5;

        case 6:
          return this.input6;
      }

      return "";
    },

    onFieldInput(event) {
      const {
        target
      } = event;
      const fieldNum = this.getFieldNumber(target);

      if (fieldNum) {
        const val = this.getField(fieldNum);

        if (val && val.length > 1) {
          this.setField(fieldNum, val.slice(0, 1));
        }
      }

      this.focusNextField(target);
    },

    onFieldFocus(event) {
      const {
        target
      } = event;
      const fieldNum = this.getFieldNumber(target);

      if (fieldNum) {
        const val = this.getField(fieldNum);

        if (val) {
          this.setField(fieldNum, "");
        }
      }
    },

    onFieldKeyDown(event) {
      const arrowCodes = [LEFT_ARROW_KEY, BACKSPACE_KEY, UP_ARROW_KEY, RIGHT_ARROW_KEY, DOWN_ARROW_KEY];
      const nextKeys = [13]; // tab, enter

      const {
        target,
        keyCode
      } = event;
      const fieldNum = this.getFieldNumber(target);

      if (arrowCodes.includes(keyCode)) {
        // if right or left arrow
        if ([UP_ARROW_KEY, LEFT_ARROW_KEY, BACKSPACE_KEY].includes(keyCode)) {
          if (keyCode === BACKSPACE_KEY) {
            this.setField(fieldNum, "");
          } // left


          this.focusPrevField(target);
        } else {
          // right
          this.focusNextField(target);
        }
      } else if (nextKeys.includes(keyCode)) {
        // if enter
        this.focusNextField(target);
      }
    },

    focusNextField(currentField) {
      const MAX = 6;
      const fieldNum = this.getFieldNumber(currentField);

      if (fieldNum && fieldNum + 1 <= MAX) {
        const nextFieldNum = fieldNum + 1;
        const nextField = this.$refs[`input${nextFieldNum}`];

        if (nextField) {
          nextField.focus();
        }
      }
    },

    focusPrevField(currentField) {
      const MIN = 1;
      const fieldNum = this.getFieldNumber(currentField);

      if (fieldNum && fieldNum - 1 >= MIN) {
        const nextFieldNum = fieldNum - 1;
        const nextField = this.$refs[`input${nextFieldNum}`];

        if (nextField) {
          nextField.focus();
        }
      }
    },

    onFieldPaste(event) {
      const {
        clipboardData
      } = event;
      const pasteData = clipboardData.getData("text");

      for (let index = 0; index < 6; index++) {
        const pasteValue = pasteData.substr(index, 1);
        const field = this.$refs[`input${index + 1}`];

        if (field) {
          field.blur();
          this.setField(index + 1, pasteValue);
        }
      }
    }

  },
  computed: {
    verifyCode: function () {
      const {
        input1,
        input2,
        input3,
        input4,
        input5,
        input6
      } = this;
      return `${input1}${input2}${input3}${input4}${input5}${input6}`;
    }
  }
});

/* script */
const __vue_script__$q = script$q;
/* template */

var __vue_render__$o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "auth-code-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input1,
      expression: "input1"
    }],
    ref: "input1",
    attrs: {
      "type": "text",
      "pattern": "\\d*",
      "maxlength": "1",
      "name": "input1",
      "disabled": _vm.loading
    },
    domProps: {
      "value": _vm.input1
    },
    on: {
      "keydown": _vm.onFieldKeyDown,
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.input1 = $event.target.value;
      }, _vm.onFieldInput],
      "paste": _vm.onFieldPaste,
      "focus": _vm.onFieldFocus
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input2,
      expression: "input2"
    }],
    ref: "input2",
    attrs: {
      "type": "text",
      "pattern": "\\d*",
      "maxlength": "1",
      "name": "input2",
      "disabled": _vm.loading
    },
    domProps: {
      "value": _vm.input2
    },
    on: {
      "keydown": _vm.onFieldKeyDown,
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.input2 = $event.target.value;
      }, _vm.onFieldInput],
      "focus": _vm.onFieldFocus
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input3,
      expression: "input3"
    }],
    ref: "input3",
    attrs: {
      "type": "text",
      "pattern": "\\d*",
      "maxlength": "1",
      "name": "input3",
      "disabled": _vm.loading
    },
    domProps: {
      "value": _vm.input3
    },
    on: {
      "keydown": _vm.onFieldKeyDown,
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.input3 = $event.target.value;
      }, _vm.onFieldInput],
      "focus": _vm.onFieldFocus
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input4,
      expression: "input4"
    }],
    ref: "input4",
    attrs: {
      "type": "text",
      "pattern": "\\d*",
      "maxlength": "1",
      "name": "input4",
      "disabled": _vm.loading
    },
    domProps: {
      "value": _vm.input4
    },
    on: {
      "keydown": _vm.onFieldKeyDown,
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.input4 = $event.target.value;
      }, _vm.onFieldInput],
      "focus": _vm.onFieldFocus
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input5,
      expression: "input5"
    }],
    ref: "input5",
    attrs: {
      "type": "text",
      "pattern": "\\d*",
      "maxlength": "1",
      "name": "input5",
      "disabled": _vm.loading
    },
    domProps: {
      "value": _vm.input5
    },
    on: {
      "keydown": _vm.onFieldKeyDown,
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.input5 = $event.target.value;
      }, _vm.onFieldInput],
      "focus": _vm.onFieldFocus
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input6,
      expression: "input6"
    }],
    ref: "input6",
    attrs: {
      "type": "text",
      "pattern": "\\d*",
      "maxlength": "1",
      "name": "input6",
      "disabled": _vm.loading
    },
    domProps: {
      "value": _vm.input6
    },
    on: {
      "keydown": _vm.onFieldKeyDown,
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.input6 = $event.target.value;
      }, _vm.onFieldInput],
      "focus": _vm.onFieldFocus
    }
  })]);
};

var __vue_staticRenderFns__$o = [];
/* style */

const __vue_inject_styles__$q = function (inject) {
  if (!inject) return;
  inject("data-v-6d538700_0", {
    source: ".spacer[data-v-6d538700]{margin-left:6px;width:42px;line-height:48px;font-size:24px;text-align:center}.auth-code-input[data-v-6d538700]{display:flex;flex-direction:row;justify-content:space-between}.auth-code-input input[data-v-6d538700]{border:1px solid #ddd;margin-left:6px;width:42px;line-height:48px;font-size:18px;text-align:center;box-shadow:inset 0 1px 2px 0 rgba(0,0,0,.2)}.auth-code-input input[data-v-6d538700]:first-child{margin-left:0}.auth-code-input input[data-v-6d538700]::-webkit-inner-spin-button,.auth-code-input input[data-v-6d538700]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.auth-code-input input[type=number][data-v-6d538700]{-moz-appearance:textfield}input[type=text][data-v-6d538700]:disabled{background:#ddd}input[type=text][data-v-6d538700]:focus{border:2px solid #8caed2;outline:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$q = "data-v-6d538700";
/* module identifier */

const __vue_module_identifier__$q = undefined;
/* functional template */

const __vue_is_functional_template__$q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, createInjector, undefined, undefined);

var __vue_component__$y = __vue_component__$x;

var script$p = Vue.extend({
  name: "INFDatePicker",
  components: {
    "el-date-picker": DatePicker,
    "el-tooltip": Tooltip
  },
  props: {
    type: {
      type: String,
      default: "datetime"
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Select"
    },
    value: {
      type: [Date, String]
    },
    required: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showFieldAs: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      required: false,
      default: ""
    },
    fieldGroupClass: {
      type: String,
      required: false,
      default: ""
    },
    fixedLabels: {
      type: Boolean,
      required: false,
      default: false
    },
    pickerOptions: {
      type: Object,
      required: false,
      default: () => ({
        disabledDate: d => !isToday(d) && isBefore(d, new Date())
      })
    }
  },
  watch: {
    value: {
      handler: function (value) {
        this.sample_text = value;
      },
      deep: true,
      immediate: true
    }
  },

  data() {
    return {
      sample_text: addMinutes(new Date(), 10),
      isFocused: false,
      isMouseOver: false
    };
  },

  methods: {
    onEnter() {
      this.$emit("onEnter");
    },

    onTab() {
      this.$emit("onTab", this);
    },

    emitChange(v) {
      this.$emit("change", v);
    },

    focusField() {
      this.isFocused = true;
    },

    blurField() {
      this.isFocused = false;
    },

    focusFieldHover() {
      this.isMouseOver = true;
    },

    blurFieldHover() {
      this.isMouseOver = false;
    },

    maybeFocusField() {
      if (!this.isFocused || !this.sample_text) {
        this.focusField();
        this.$nextTick(this.focusFieldRef);
      }
    },

    focusFieldRef() {
      try {
        const fieldRef = this.$refs.selectField;
        const field = fieldRef.$el;

        if (field) {
          field.focus();
          field.click();
        }
      } catch (error) {
        /* Do Nothing */
      }
    },

    disabledDate(d) {
      return !isToday(d) && isBefore(d, new Date());
    }

  },
  computed: {
    hasError() {
      return this.required && this.value === "";
    },

    displayIcon() {
      if (this.loading) {
        return "spinner";
      }

      if (!this.required) {
        return "";
      }

      if (this.sample_text) {
        return "check";
      }

      return "asterisk";
    },

    defaultTime() {
      const now = new Date();
      return `${format$1(addMinutes(now, 5), "HH:mm:ss")}`;
    }

  }
});

/* script */
const __vue_script__$p = script$p;
/* template */

var __vue_render__$n = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "form-group",
    class: (_obj = {
      hasError: _vm.hasError,
      isFocus: _vm.isFocused || _vm.isMouseOver,
      hasValue: _vm.value && _vm.value !== '',
      fixedLabels: _vm.fixedLabels
    }, _obj[_vm.fieldGroupClass] = true, _obj)
  }, [_c('div', {
    staticClass: "form-field form-field-date"
  }, [_c('label', {
    class: _vm.labelClass,
    on: {
      "click": _vm.maybeFocusField
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('el-date-picker', {
    ref: "textField",
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.isFocused ? _vm.placeholder : "",
      "autocomplete": "none",
      "format": _vm.type === 'datetime' ? 'MM/dd/yyyy h:mma' : 'MM/dd/yyyy',
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "clearable": _vm.clearable,
      "default-time": _vm.defaultTime,
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.emitChange,
      "focus": _vm.focusField,
      "blur": _vm.blurField
    },
    nativeOn: {
      "focus": function ($event) {
        return _vm.focusField.apply(null, arguments);
      },
      "blur": function ($event) {
        return _vm.blurField.apply(null, arguments);
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }

        return _vm.onTab.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.onEnter.apply(null, arguments);
      }]
    },
    model: {
      value: _vm.sample_text,
      callback: function ($$v) {
        _vm.sample_text = $$v;
      },
      expression: "sample_text"
    }
  }), _vm._v(" "), _vm.displayIcon ? _c('el-tooltip', {
    attrs: {
      "tabindex": 9999,
      "disabled": _vm.required,
      "content": "Required",
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "icon",
    class: "icon-" + _vm.displayIcon,
    attrs: {
      "tabindex": 9999
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fas', _vm.displayIcon]
    }
  })], 1)]) : _vm._e()], 1)]);
};

var __vue_staticRenderFns__$n = [];
/* style */

const __vue_inject_styles__$p = function (inject) {
  if (!inject) return;
  inject("data-v-a0ccb096_0", {
    source: ".form-field[data-v-a0ccb096]{position:relative}.form-field label[data-v-a0ccb096]{position:absolute;top:12px;left:12px;font-size:14px;z-index:1;transition:all ease-in-out .24s;line-height:1.2}.form-field.form-field-date label[data-v-a0ccb096]{left:33px}.form-field.form-field-switch label[data-v-a0ccb096],.hasValue .form-field label[data-v-a0ccb096],.isFocus .form-field label[data-v-a0ccb096]{top:-15px;left:2px;font-size:11px}.fixedLabels .form-field label[data-v-a0ccb096]{top:-15px;left:2px;font-size:11px}.form-field-h1 input[data-v-a0ccb096],.form-field-h2 input[data-v-a0ccb096],.form-field-p input[data-v-a0ccb096]{border:none}.form-field-h1 input[data-v-a0ccb096]{font-size:30px}.isFocus .form-field-h1 input[data-v-a0ccb096],.isFocus .form-field-h2 input[data-v-a0ccb096],.isFocus .form-field-p input[data-v-a0ccb096]{border:1px solid #dcdfe6}.error-message[data-v-a0ccb096]{font-weight:600;color:#ef4444;font-size:12px;line-height:1;margin:4px 0 0 3px;position:absolute}.form-field .icon[data-v-a0ccb096]{position:absolute;z-index:9;right:12px;bottom:12px}.isFocus .form-field .icon[data-v-a0ccb096]{display:none}.form-field .icon svg[data-v-a0ccb096]{width:12px}.field-right[data-v-a0ccb096]{float:right}.icon-asterisk[data-v-a0ccb096],.icon-times[data-v-a0ccb096]{color:#ef4444}.isFocus .icon-asterisk[data-v-a0ccb096],.isFocus .icon-times[data-v-a0ccb096]{color:#fca5a5}.icon-check[data-v-a0ccb096]{color:#34d399}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$p = "data-v-a0ccb096";
/* module identifier */

const __vue_module_identifier__$p = undefined;
/* functional template */

const __vue_is_functional_template__$p = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, createInjector, undefined, undefined);

var INFDatePicker = __vue_component__$w;

var script$o = Vue.extend({
  name: "INFDatePicker",
  components: {
    "el-date-picker": DatePicker,
    "el-tooltip": Tooltip,
    "el-time-picker": TimePicker
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Select"
    },
    value: {
      type: [Date, String]
    },
    required: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showFieldAs: {
      type: String,
      default: ""
    },
    pickerOptions: {
      type: Object,
      required: false,
      default: () => ({
        disabledDate: d => !isToday(d) && isBefore(d, new Date())
      })
    }
  },
  watch: {
    value: {
      handler: function (value) {
        if (value) {
          let date = value instanceof Date ? value : parseISO(value);

          if (isPast(date)) {
            date = this.makeDefaultDateTime();
          }

          this.field_value_date = date;
          this.field_value_time = date;
        }
      },
      immediate: true
    },
    dateTimeValue: {
      handler: function (value) {
        if (value) {
          const date = value instanceof Date ? value : parseISO(value);

          if (isPast(date)) {
            this.field_value_time = this.makeDefaultDateTime();
          }
        }
      },
      immediate: true
    }
  },

  data() {
    return {
      sample_text: addMinutes(new Date(), 10),
      field_value_time: addMinutes(new Date(), 10),
      field_value_date: new Date(),
      isFocused: false,
      isMouseOver: false
    };
  },

  methods: {
    onEnter() {
      this.$emit("onEnter");
    },

    emitChange() {
      this.$emit("change", this.dateTimeValue);
    },

    focusField() {
      this.isFocused = true;
    },

    blurField() {
      this.isFocused = false;
    },

    focusFieldHover() {
      this.isMouseOver = true;
    },

    blurFieldHover() {
      this.isMouseOver = false;
    },

    maybeFocusField() {
      if (!this.isFocused || !this.field_value_date) {
        this.focusField();
        this.$nextTick(this.focusFieldRef);
      }
    },

    focusFieldRef() {
      try {
        const fieldRef = this.$refs.selectField;
        const field = fieldRef.$el;
        field.focus();
        field.click();
      } catch (error) {
        /* Do Nothing */
      }
    },

    makeDefaultDateTime() {
      return addMinutes(new Date(), 10);
    }

  },
  computed: {
    dateTimeValue() {
      const {
        field_value_date,
        field_value_time
      } = this;
      const date = format$1(field_value_date instanceof Date ? field_value_date : parseISO(field_value_date), "yyyy-MM-dd");
      const time = format$1(field_value_time instanceof Date ? field_value_time : parseISO(field_value_time), "HH:mm:ss.SSSxxx");
      return setSeconds(parseISO(`${date}T${time}`), 0);
    },

    hasError() {
      return this.required && this.value === "";
    },

    displayIcon: function () {
      if (this.loading) {
        return "spinner";
      }

      if (!this.required) {
        return "";
      }

      if (this.dateTimeValue) {
        return "check";
      }

      return "asterisk";
    }
  }
});

/* script */
const __vue_script__$o = script$o;
/* template */

var __vue_render__$m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "form-group pb-12",
    class: {
      hasError: _vm.hasError,
      isFocus: _vm.isFocused || _vm.isMouseOver,
      hasValue: _vm.field_value_date && _vm.field_value_date !== ''
    }
  }, [_c('div', {
    staticClass: "form-field form-field-date"
  }, [_c('label', {
    on: {
      "click": _vm.maybeFocusField
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('el-date-picker', {
    ref: "textField",
    attrs: {
      "type": "date",
      "placeholder": _vm.isFocused ? _vm.placeholder : "",
      "autocomplete": "none",
      "format": 'M/d/yyyy',
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "clearable": false,
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.emitChange,
      "focus": _vm.focusField,
      "blur": _vm.blurField
    },
    nativeOn: {
      "focus": function ($event) {
        return _vm.focusField.apply(null, arguments);
      },
      "blur": function ($event) {
        return _vm.blurField.apply(null, arguments);
      }
    },
    model: {
      value: _vm.field_value_date,
      callback: function ($$v) {
        _vm.field_value_date = $$v;
      },
      expression: "field_value_date"
    }
  }), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "format": "h:mm a",
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "placeholder": "Time"
    },
    on: {
      "change": _vm.emitChange
    },
    model: {
      value: _vm.field_value_time,
      callback: function ($$v) {
        _vm.field_value_time = $$v;
      },
      expression: "field_value_time"
    }
  })], 1), _vm._v(" "), _vm.displayIcon ? _c('el-tooltip', {
    attrs: {
      "tabindex": 9999,
      "disabled": _vm.required,
      "content": "Required",
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "icon",
    class: "icon-" + _vm.displayIcon,
    attrs: {
      "tabindex": 9999
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fas', _vm.displayIcon]
    }
  })], 1)]) : _vm._e()], 1)]);
};

var __vue_staticRenderFns__$m = [];
/* style */

const __vue_inject_styles__$o = function (inject) {
  if (!inject) return;
  inject("data-v-0cb03e92_0", {
    source: ".form-field[data-v-0cb03e92]{position:relative}.form-field label[data-v-0cb03e92]{position:absolute;top:12px;left:12px;font-size:14px;z-index:1;transition:all ease-in-out .24s;line-height:1.2}.form-field.form-field-date label[data-v-0cb03e92]{left:33px}.form-field.form-field-switch label[data-v-0cb03e92],.hasValue .form-field label[data-v-0cb03e92],.isFocus .form-field label[data-v-0cb03e92]{top:-15px;left:2px;font-size:11px}.form-field-h1 input[data-v-0cb03e92],.form-field-h2 input[data-v-0cb03e92],.form-field-p input[data-v-0cb03e92]{border:none}.form-field-h1 input[data-v-0cb03e92]{font-size:30px}.isFocus .form-field-h1 input[data-v-0cb03e92],.isFocus .form-field-h2 input[data-v-0cb03e92],.isFocus .form-field-p input[data-v-0cb03e92]{border:1px solid #dcdfe6}.error-message[data-v-0cb03e92]{color:#ef4444;font-weight:600;font-size:12px;line-height:1;margin:4px 0 0 3px;position:absolute}.form-field .icon[data-v-0cb03e92]{position:absolute;z-index:9;right:13px;bottom:12px}.isFocus .form-field .icon[data-v-0cb03e92]{display:none}.form-field .icon svg[data-v-0cb03e92]{width:12px}.field-right[data-v-0cb03e92]{float:right}.icon-asterisk[data-v-0cb03e92],.icon-times[data-v-0cb03e92]{color:#ef4444}.isFocus .icon-asterisk[data-v-0cb03e92],.isFocus .icon-times[data-v-0cb03e92]{color:#fca5a5}.icon-check[data-v-0cb03e92]{color:#34d399}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$o = "data-v-0cb03e92";
/* module identifier */

const __vue_module_identifier__$o = undefined;
/* functional template */

const __vue_is_functional_template__$o = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, createInjector, undefined, undefined);

var __vue_component__$v = __vue_component__$u;

var script$n = Vue.extend({
  components: {
    CurrencyInput
  },
  name: "INFCurrencyInput",
  props: {
    value: {
      type: [Number, String],
      required: false,
      default: 0
    },
    locale: {
      type: String,
      default: "en-US"
    },
    currency: {
      type: [String, Object],
      default: "USD"
    },
    distractionFree: {
      type: [Boolean, Object],
      default: false
    },
    precision: {
      type: [Number, Object],
      default: 2
    },
    autoDecimalMode: {
      type: Boolean,
      default: true
    },
    valueAsInteger: {
      type: Boolean,
      default: false
    },
    valueRange: {
      type: Object,
      default: undefined
    },
    allowNegative: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium"
    }
  },
  computed: {
    dynamicStyles() {
      const styleClasses = ["el-input__inner"];
      const sizeStyleClasses = {
        mini: "el-input--mini",
        large: "el-input--large",
        medium: "el-input--medium",
        size: "el-input--small"
      };
      styleClasses.push(sizeStyleClasses[this.size]);
      return styleClasses.join(" ");
    }

  }
});

/* script */
const __vue_script__$n = script$n;
/* template */

var __vue_render__$l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('CurrencyInput', {
    class: _vm.dynamicStyles,
    attrs: {
      "value": typeof _vm.value === 'string' || isNaN(_vm.value) ? 0 : _vm.value,
      "required": true,
      "currency": _vm.currency,
      "locale": _vm.locale,
      "precision": _vm.precision,
      "allowNegative": _vm.allowNegative,
      "distractionFree": _vm.distractionFree,
      "autoDecimalMode": _vm.autoDecimalMode,
      "valueAsInteger": _vm.valueAsInteger,
      "disabled": _vm.disabled
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      },
      "change": function ($event) {
        return _vm.$emit('change', $event);
      }
    }
  });
};

var __vue_staticRenderFns__$l = [];
/* style */

const __vue_inject_styles__$n = function (inject) {
  if (!inject) return;
  inject("data-v-aecf6858_0", {
    source: ".el-input--large[data-v-aecf6858]{padding-top:2rem;padding-bottom:2rem;height:5rem;font-size:4rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$n = "data-v-aecf6858";
/* module identifier */

const __vue_module_identifier__$n = undefined;
/* functional template */

const __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);

var __vue_component__$t = __vue_component__$s;

var script$m = Vue.extend({
  components: {
    INFTextField: INFTextField$1
  },
  props: {
    taxId: {
      type: String,
      default: ""
    },
    taxIdMaskType: {
      type: String,
      required: false
    },
    defaultTaxIdMask: {
      type: String,
      default: "SSN",
      validator: val => {
        return val === "SSN" || val === "EIN";
      }
    },
    fieldGroupClass: {
      type: String,
      default: "pb-12"
    },
    required: {
      type: Boolean,
      default: true,
      required: false
    },
    label: {
      type: String,
      default: "Tax Id",
      required: false
    },
    placeholder: {
      type: String,
      default: "xxx-xx-2077",
      required: false
    },
    labelClass: {
      type: String,
      required: false,
      default: ""
    },
    prefixIcon: {
      type: String,
      required: false,
      default: ""
    },
    suffixIcon: {
      type: String,
      required: false,
      default: ""
    },
    fixedLabels: {
      type: Boolean,
      default: false
    },
    showMaskSelector: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data() {
    return {
      editTaxId: false,
      value: "",
      origValue: "",
      taxIdMask: "SSN"
    };
  },

  mounted() {
    if (this.taxIdMaskType) {
      this.taxIdMask = this.taxIdMaskType;
    } else {
      this.taxIdMask = this.defaultTaxIdMask;
    }
  },

  methods: {
    onFieldBlurred() {
      if (this.taxIdMask === "SSN" && this.value.length === 11 || this.taxIdMask === "EIN" && this.value.length === 10) {
        this.$emit("input", this.value);
      } else {
        this.value = this.origValue;
      }

      this.editTaxId = false;
      this.$emit("blur");
    },

    onFieldChanged() {
      if (this.taxIdMask === "SSN" && this.value.length === 11 || this.taxIdMask === "EIN" && this.value.length === 10) {
        this.$emit("change", this.value);
      } else {
        this.value = this.origValue;
      }

      this.editTaxId = false;
    },

    changeTaxIdMaskingFormat(maskingFormat) {
      this.taxIdMask = maskingFormat;
      this.$emit("taxIdMaskChanged", maskingFormat);
    }

  },
  watch: {
    taxId: {
      handler(v) {
        this.origValue = v;
        this.value = v;
      },

      immediate: true
    }
  },
  computed: {
    taxIdValueMasked() {
      const taxId = this.value;

      if (this.taxIdMask === "SSN") {
        return "xxx-xx-" + taxId.substr(taxId.length - 4);
      } else {
        return "xx-xxx" + taxId.substr(taxId.length - 4);
      }
    },

    getTaxIdValidation: function () {
      const validations = [{
        method: "minLength",
        value: this.taxIdMask === "SSN" ? 11 : 10,
        error: `Minimum 9 characters!`
      }, {
        method: "maxLength",
        value: this.taxIdMask === "SSN" ? 11 : 10,
        error: `Maximum 9 characters`
      }];
      return validations;
    }
  }
});

/* script */
const __vue_script__$m = script$m;
/* template */

var __vue_render__$k = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "relative",
    class: (_obj = {}, _obj[_vm.fieldGroupClass] = true, _obj)
  }, [!_vm.editTaxId && _vm.taxId ? _c('div', {
    staticClass: "w-2/2 el-input__inner relative"
  }, [_c('label', {
    staticClass: "taxId"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('span', {
    on: {
      "click": function ($event) {
        _vm.editTaxId = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.taxIdValueMasked))])]) : _c('INFTextField', {
    ref: "field_taxId",
    attrs: {
      "type": "taxId",
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "value": '',
      "required": _vm.required,
      "focusOnMount": _vm.editTaxId,
      "defaultTaxIdMask": _vm.taxIdMask,
      "validations": _vm.getTaxIdValidation,
      "prefixIcon": _vm.prefixIcon,
      "suffixIcon": _vm.suffixIcon,
      "labelClass": _vm.labelClass,
      "fixedLabels": _vm.fixedLabels,
      "disabled": _vm.disabled
    },
    on: {
      "input": function ($event) {
        _vm.value = $event;
      },
      "blur": _vm.onFieldBlurred,
      "change": _vm.onFieldChanged
    },
    scopedSlots: _vm._u([_vm._l(_vm.$slots, function (index, name) {
      return {
        key: name,
        fn: function () {
          return [_vm._t(name)];
        },
        proxy: true
      };
    })], null, true)
  }), _vm._v(" "), _vm.showMaskSelector ? _c('div', {
    staticClass: "flex absolute right-0",
    staticStyle: {
      "top": "-22px"
    }
  }, [_c('div', {
    staticClass: "ml-auto"
  }, [_c('span', {
    staticClass: "cursor-pointer text-xs",
    class: _vm.taxIdMask === 'SSN' ? 'text-blue-500' : 'text-gray-500',
    on: {
      "click": function ($event) {
        return _vm.changeTaxIdMaskingFormat('SSN');
      }
    }
  }, [_vm._v("SSN")]), _vm._v(" "), _c('span', {
    staticClass: "mx-1 text-xs text-gray-400"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer text-xs",
    class: _vm.taxIdMask === 'EIN' ? 'text-blue-500' : 'text-gray-500',
    on: {
      "click": function ($event) {
        return _vm.changeTaxIdMaskingFormat('EIN');
      }
    }
  }, [_vm._v("EIN")])])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$k = [];
/* style */

const __vue_inject_styles__$m = function (inject) {
  if (!inject) return;
  inject("data-v-d81a2fca_0", {
    source: ".taxId[data-v-d81a2fca]{position:absolute;top:-15px;left:7px;font-size:11px;z-index:1;line-height:1.2}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$m = "data-v-d81a2fca";
/* module identifier */

const __vue_module_identifier__$m = undefined;
/* functional template */

const __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);

var __vue_component__$r = __vue_component__$q;

Vue.use(Loading.directive);
const allowedFitTypes = ["fill", "contain", "cover", "none", "scale-down"];
var script$l = Vue.extend({
  name: "INFImage",
  props: {
    id: {
      type: String,
      default: function () {
        return Math.random().toString(36).substring(7);
      }
    },
    src: {
      type: String,
      default: "",
      required: true
    },
    width: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    fit: {
      type: String,
      default: "fill",
      validator: val => allowedFitTypes.includes(val)
    },
    lazy: {
      type: Boolean,
      default: false
    },
    customStyle: {
      type: String,
      default: "object-fit: cover;"
    }
  },

  data() {
    return {
      imageReady: false,
      loading: true,
      imageError: false,
      imageSrc: ""
    };
  },

  methods: {
    onImageLoaded() {
      this.$nextTick(() => {
        this.loading = false;
      });
    }

  }
});

/* script */
const __vue_script__$l = script$l;
/* template */

var __vue_render__$j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "el-image",
    attrs: {
      "id": _vm.id
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('img', {
    style: _vm.customStyle,
    attrs: {
      "id": "image-" + _vm.id,
      "alt": _vm.alt,
      "src": _vm.src
    },
    on: {
      "load": _vm.onImageLoaded,
      "error": _vm.onImageLoaded
    }
  })])], 1);
};

var __vue_staticRenderFns__$j = [];
/* style */

const __vue_inject_styles__$l = function (inject) {
  if (!inject) return;
  inject("data-v-5a20fdbc_0", {
    source: ".fade-enter-active[data-v-5a20fdbc],.fade-leave-active[data-v-5a20fdbc]{transition:opacity .5s}.fade-enter[data-v-5a20fdbc],.fade-leave-to[data-v-5a20fdbc]{opacity:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$l = "data-v-5a20fdbc";
/* module identifier */

const __vue_module_identifier__$l = undefined;
/* functional template */

const __vue_is_functional_template__$l = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, createInjector, undefined, undefined);

var __vue_component__$p = __vue_component__$o;

var script$k = Vue.extend({
  props: {
    value: {
      type: Number,
      required: true,
      default: 0
    },
    notation: {
      type: String,
      required: false,
      default: "compact" //scientific, engineering, standard, compact

    },
    compactDisplay: {
      type: String,
      required: false,
      default: "long"
    },
    currency: {
      type: String,
      required: false,
      default: "USD"
    }
  },
  computed: {
    formattedValue() {
      const formatOptions = {};
      formatOptions.style = "currency";
      formatOptions.currency = this.currency;
      formatOptions.notation = this.notation;

      if (formatOptions.notation) {
        formatOptions.compactDisplay = this.compactDisplay;
      }

      return new Intl.NumberFormat("en-US", formatOptions).format(this.value);
    }

  }
});

/* script */
const __vue_script__$k = script$k;
/* template */

var __vue_render__$i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', [_vm._v("\n  " + _vm._s(_vm.formattedValue) + "\n")]);
};

var __vue_staticRenderFns__$i = [];
/* style */

const __vue_inject_styles__$k = undefined;
/* scoped */

const __vue_scope_id__$k = undefined;
/* module identifier */

const __vue_module_identifier__$k = undefined;
/* functional template */

const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

var __vue_component__$n = __vue_component__$m;

var templateRenderFns$1 = [];
var script$j = Vue.extend({
  props: {
    tag: {
      type: String,
      required: true,
      validator: function (v) {
        return ["p", "span", "h1", "h2", "h3", "h4", "h5", "h6"].includes(v);
      }
    },
    namespace: {
      type: String,
      required: true
    },
    stringKey: {
      type: String,
      required: true
    },
    options: {
      type: Object
    }
  },

  data() {
    return {
      templateRender: null,
      templateRenderFns: []
    };
  },

  render() {
    return this.templateRender ? this.templateRender(this.tag) : "";
  },

  staticRenderFns: templateRenderFns$1,
  watch: {
    stringKey: {
      immediate: true,

      handler() {
        const getTextString = this.__getString(this.namespace, this.stringKey);

        const compiledTemplate = ProdVue.compile(`<${this.tag}>${getTextString}</${this.tag}>`);
        this.templateRender = compiledTemplate.render;

        for (const i in compiledTemplate.staticRenderFns) {
          templateRenderFns$1.push(compiledTemplate.staticRenderFns[i]);
        }
      }

    }
  }
});

/* script */
const __vue_script__$j = script$j;
/* template */

/* style */

const __vue_inject_styles__$j = undefined;
/* scoped */

const __vue_scope_id__$j = undefined;
/* module identifier */

const __vue_module_identifier__$j = undefined;
/* functional template */

const __vue_is_functional_template__$j = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

var __vue_component__$l = __vue_component__$k;

var templateRenderFns = [];
var script$i = Vue.extend({
  data() {
    return {
      templateRender: null,
      templateRenderFns: [],
      ...this.templateData
    };
  },

  props: {
    html: String,
    templateData: {
      type: Object,
      default: () => ({})
    }
  },

  render() {
    return this.templateRender ? this.templateRender("div") : "";
  },

  staticRenderFns: templateRenderFns,
  watch: {
    html: {
      immediate: true,

      handler() {
        const compiledTemplate = ProdVue.compile(this.html);
        this.templateRender = compiledTemplate.render;

        for (const i in compiledTemplate.staticRenderFns) {
          templateRenderFns.push(compiledTemplate.staticRenderFns[i]);
        }
      }

    }
  }
});

/* script */
const __vue_script__$i = script$i;
/* template */

/* style */

const __vue_inject_styles__$i = undefined;
/* scoped */

const __vue_scope_id__$i = undefined;
/* module identifier */

const __vue_module_identifier__$i = undefined;
/* functional template */

const __vue_is_functional_template__$i = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

var __vue_component__$j = __vue_component__$i;

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    INFButton: INFButton,
    INFTextField: INFTextField,
    INFSelectField: INFSelectField,
    INFCustomDatePicker: __vue_component__$G,
    INFPageMessage: __vue_component__$E,
    INFPageButton: __vue_component__$C,
    INFContentCard: __vue_component__$A,
    INFAuthCodeInput: __vue_component__$y,
    INFDatePicker: INFDatePicker,
    INFDateTimePicker: __vue_component__$v,
    INFCurrencyInput: __vue_component__$t,
    INFTaxIdField: __vue_component__$r,
    INFImage: __vue_component__$p,
    INFCurrencyFormatter: __vue_component__$n,
    INFGetText: __vue_component__$l,
    INFHTMLContent: __vue_component__$j
});

var script$h = Vue.extend({
  name: "action-links",
  components: {
    INFButton,
    "el-col": Col,
    "el-row": Row
  },
  computed: { ...listViewModuleMapState(["listViewStoreReady", "actionLinks"])
  }
});

/* script */
const __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.listViewStoreReady ? _c('div', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, _vm._l(_vm.actionLinks, function (action) {
    return _c('div', {
      key: action.title
    }, [_c('el-col', {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "span": 2
      }
    }, [_c('INFButton', {
      attrs: {
        "title": action.title,
        "click": action.callback,
        "type": action.type,
        "disabled": action.disabled,
        "id": action.id,
        "size": action.size
      }
    })], 1)], 1);
  }), 0), _vm._v(" "), _c('br')], 1) : _vm._e();
};

var __vue_staticRenderFns__$h = [];
/* style */

const __vue_inject_styles__$h = undefined;
/* scoped */

const __vue_scope_id__$h = undefined;
/* module identifier */

const __vue_module_identifier__$h = undefined;
/* functional template */

const __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

var ActionLinks = __vue_component__$h;

var script$g = Vue.extend({
  name: "toggle-icons",
  components: {
    "font-awesome-icon": FontAwesomeIcon
  },
  props: {
    hideTableSimpleFilterIcon: {
      type: Boolean
    }
  },

  data() {
    return {};
  },

  computed: { ...listViewModuleMapState(["listViewStoreReady", "showAdvancedTableFilter", "showSimpleTableFilter"])
  },

  beforeDestroy() {
    this.SET_LIST_VIEW_MODULE_STATE({
      key: "showAdvancedTableFilter",
      value: false
    });
    this.SET_LIST_VIEW_MODULE_STATE({
      key: "showSimpleTableFilter",
      value: false
    });
  },

  methods: { ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE"]),

    showAdvancedFilter() {
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "showAdvancedTableFilter",
        value: true
      });
    },

    showSimpleFilter() {
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "showSimpleTableFilter",
        value: true
      });
    },

    closeAdvancedFilter() {
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "showAdvancedTableFilter",
        value: false
      });
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "showSimpleTableFilter",
        value: false
      });
    }

  }
});

/* script */
const __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.listViewStoreReady ? _c('div', {
    staticClass: "flex items-center",
    class: {
      'justify-end': _vm.showAdvancedTableFilter || _vm.showSimpleTableFilter,
      'justify-start': !_vm.showAdvancedTableFilter || !_vm.showSimpleTableFilter
    }
  }, [_vm.showAdvancedTableFilter || _vm.showSimpleTableFilter ? _c('div', {}, [_c('span', {
    staticClass: "text-gray-500 el-button--text",
    on: {
      "click": _vm.closeAdvancedFilter
    }
  }, [_c('font-awesome-icon', {
    staticClass: "close-icon",
    attrs: {
      "icon": ['fal', 'window-close']
    }
  })], 1)]) : _vm._e(), _vm._v(" "), !_vm.showAdvancedTableFilter && !_vm.showSimpleTableFilter ? _c('div', {
    staticClass: "w-1/3"
  }, [_c('span', {
    staticClass: "text-gray-500 cursor-pointer toggle-icon el-button--text",
    on: {
      "click": _vm.showAdvancedFilter
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', 'filter']
    }
  })], 1)]) : _vm._e(), _vm._v(" "), !_vm.showAdvancedTableFilter && !_vm.showSimpleTableFilter && !_vm.hideTableSimpleFilterIcon ? _c('div', {
    staticClass: "w-1/3"
  }, [_c('span', {
    staticClass: "text-gray-500 cursor-pointer toggle-icon el-button--text",
    staticStyle: {
      "margin-left": "0.3rem"
    },
    on: {
      "click": _vm.showSimpleFilter
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', 'gavel']
    }
  })], 1)]) : _vm._e()]) : _vm._e();
};

var __vue_staticRenderFns__$g = [];
/* style */

const __vue_inject_styles__$g = undefined;
/* scoped */

const __vue_scope_id__$g = undefined;
/* module identifier */

const __vue_module_identifier__$g = undefined;
/* functional template */

const __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

var ToggleIcons = __vue_component__$g;

var script$f = Vue.extend({
  name: "active-filters",
  components: {
    "font-awesome-icon": FontAwesomeIcon,
    "el-col": Col,
    "el-row": Row
  },
  methods: { ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE"]),

    getOperationLabel(operation) {
      return this.filterQueryOperations.find(op => op.value === operation).label;
    },

    async removeQueryFromFilters(index) {
      const queryFilters = cloneDeep(this.activeFilterQueries);
      const filter = queryFilters[index];
      const routeQuery = cloneDeep(this.$route.query); //! remove query from filters

      queryFilters.splice(index, 1); //! remove query from url

      const fieldKey = `${filter.field}${filter.operation}`;
      delete routeQuery[fieldKey];
      await this.$router.replace({}).catch(() => {});
      await this.$router.replace({
        query: routeQuery
      }).catch(() => {});
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "activeFilterQueries",
        value: queryFilters
      });
    }

  },
  computed: { ...listViewModuleMapState(["listViewStoreReady", "filterQueryOperations", "activeFilterQueries"]),
    getActiveFilterQueries: function () {
      return this.activeFilterQueries.filter(query => query.value);
    }
  }
});

/* script */
const __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.listViewStoreReady ? _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, _vm._l(_vm.getActiveFilterQueries, function (filter, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 6
      }
    }, [_c('span', {
      staticClass: "delete-icon",
      on: {
        "click": function ($event) {
          return _vm.removeQueryFromFilters(index);
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": ['fal', 'trash-alt']
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "filter"
    }, [_c('span', {
      staticClass: "field"
    }, [_vm._v(" " + _vm._s(filter.field))]), _vm._v(" "), _c('span', {
      staticClass: "operation"
    }, [_vm._v("\n        " + _vm._s(_vm.getOperationLabel(filter.operation)))]), _vm._v(" "), _c('span', {
      staticClass: "value"
    }, [_vm._v(" " + _vm._s(filter.value))])])]);
  }), 1) : _vm._e();
};

var __vue_staticRenderFns__$f = [];
/* style */

const __vue_inject_styles__$f = function (inject) {
  if (!inject) return;
  inject("data-v-3566d376_0", {
    source: ".mb-10{margin-bottom:10px}.delete-icon{font-size:14px;margin-right:10px}.filter .field{font-size:12px;color:gray}.filter .operation{font-size:12px;color:gray}.filter .value{font-size:12px;color:#70899b}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$f = undefined;
/* module identifier */

const __vue_module_identifier__$f = undefined;
/* functional template */

const __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);

var script$e = Vue.extend({
  name: "advanced-filter",
  props: {
    size: {
      type: String,
      required: false,
      default: "small"
    }
  },
  components: {
    "active-filters": __vue_component__$f,
    INFButton,
    INFSelectField,
    INFTextField
  },

  data() {
    return {
      filters: [],
      elCollapse: [],
      filter: {
        field: "",
        operation: "",
        value: ""
      },
      error: "",
      visibleTableOptions: true,
      visibleTableFilter: true,
      queryFilters: []
    };
  },

  methods: { ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE"]),

    addFilter() {
      const {
        field,
        operation,
        value
      } = this.filter;

      if (!field || !operation || !value) {
        this.error = "please make sure all fields have values.";
      } else {
        this.error = "";
        const queryFilters = cloneDeep(this.activeFilterQueries);
        queryFilters.push({
          field,
          operation,
          value
        });
        const debounce = throttle(() => {
          this.SET_LIST_VIEW_MODULE_STATE({
            key: "activeFilterQueries",
            value: queryFilters
          });
        }, 1000);
        debounce();
        this.filter = {
          field: "",
          operation: "",
          value: ""
        };
      }
    }

  },
  computed: { ...listViewModuleMapState(["listViewStoreReady", "defaultPageSize", "tableColumnRules", "advanceFilterFields", "filterQueryOperations", "activeFilterQueries"]),
    filterFieldOptions: function () {
      return this.advanceFilterFields.map(tableColumn => ({
        value: tableColumn,
        label: typeof this.tableColumnRules[tableColumn].formatDataKey === "string" ? this.tableColumnRules[tableColumn].formatDataKey : this.tableColumnRules[tableColumn].formatDataKey()
      }));
    },
    disableAdd: function () {
      return Object.values(this.filter).filter(v => !v).length > 0;
    }
  }
});

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.listViewStoreReady ? _c('div', [_c('active-filters'), _vm._v(" "), _c('div', {
    staticClass: "flex items-baseline"
  }, [_c('INFSelectField', {
    staticClass: "advanced-filter__item",
    attrs: {
      "label": "Fields",
      "options": _vm.filterFieldOptions,
      "selected": _vm.filter.field,
      "required": true,
      "size": _vm.size
    },
    on: {
      "change": function ($event) {
        _vm.filter.field = $event;
      }
    }
  }), _vm._v(" "), _c('INFSelectField', {
    staticClass: "advanced-filter__item",
    attrs: {
      "label": "Operations",
      "options": _vm.filterQueryOperations,
      "selected": _vm.filter.operation,
      "required": true,
      "size": _vm.size
    },
    on: {
      "change": function ($event) {
        _vm.filter.operation = $event;
      }
    }
  }), _vm._v(" "), _c('INFTextField', {
    ref: "field_valueField",
    staticClass: "advanced-filter__item",
    attrs: {
      "label": "Value",
      "placeholder": 'Please enter keyword',
      "value": _vm.filter.value,
      "required": true,
      "size": _vm.size
    },
    on: {
      "input": function ($event) {
        _vm.filter.value = $event;
      }
    }
  }), _vm._v(" "), _c('INFButton', {
    staticClass: "advanced-filter__item",
    attrs: {
      "id": "filter-add-btn",
      "type": "info",
      "icon": "el-icon-plus",
      "title": '',
      "disabled": _vm.disableAdd,
      "click": _vm.addFilter,
      "size": _vm.size
    }
  })], 1)], 1) : _vm._e();
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$e = function (inject) {
  if (!inject) return;
  inject("data-v-205ae35c_0", {
    source: ".advanced-filter__item+.advanced-filter__item[data-v-205ae35c]{margin-left:1rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$e = "data-v-205ae35c";
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, createInjector, undefined, undefined);

var AdvancedFilter = __vue_component__$e;

var script$d = Vue.extend({
  name: "simple-filter",
  components: {
    "el-row": Col,
    "el-col": Row,
    INFSelectField
  },
  props: {
    size: {
      type: String,
      required: false,
      default: "small"
    }
  },

  created() {
    for (const filter of this.simpleFilterFields) {
      const key = Object.keys(filter)[0]; //Check if value exists in url;

      const routeQuery = this.$route ? cloneDeep(this.$route.query) : {};
      const routeQueryKeys = Object.keys(routeQuery);
      const queryField = `${key}__eq`;
      let columnDefaultValue = "";

      if (routeQueryKeys.includes(queryField)) {
        columnDefaultValue = routeQuery[queryField];
      }

      this.$set(this.filter, key, columnDefaultValue);
    }
  },

  watch: {
    filter: {
      handler() {
        this.prepareQuery();
      },

      deep: true,
      immediate: false
    }
  },

  data() {
    return {
      error: "",
      filter: {},
      run_query: false
    };
  },

  methods: { ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE"]),

    prepareQuery() {
      const filters = Object.keys(this.filter);

      if (filters.length) {
        const query = {};

        for (const q of filters) {
          query[`${q}__eq`] = this.filter[q];
        }

        if (this.run_query) {
          this.simpleFilterSearch(query);
        }
      }
    },

    updateField(field, value) {
      this.run_query = true;
      this.$set(this.filter, field, value);
    },

    clearQuery(index) {
      const clearingField = this.simpleFilterFields[index];

      if (clearingField) {
        const queryFieldKey = Object.keys(clearingField)[0];
        this.$set(this.filter, queryFieldKey, "");
      }
    },

    getSelectedValue(field) {
      return this.filter[field];
    },

    simpleFilterSearch(queryObject) {
      queryObject["__regex"] = true;
      const debounce = throttle(() => {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "filterQuery",
          value: queryObject
        });
      }, 1000);
      debounce();
    }

  },
  computed: { ...listViewModuleMapState(["listViewStoreReady", "defaultPageSize", "simpleFilterFields"])
  }
});

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.listViewStoreReady ? _c('div', {
    staticClass: "simple--filter"
  }, _vm._l(_vm.simpleFilterFields, function (filterField, index) {
    return _c('INFSelectField', {
      key: index,
      staticClass: "simple-filter__item",
      attrs: {
        "label": Object.keys(filterField)[0],
        "options": filterField[Object.keys(filterField)[0]],
        "selected": _vm.getSelectedValue(Object.keys(filterField)[0]),
        "clearable": true,
        "required": false,
        "fieldGroupClass": "pb-0",
        "size": _vm.size
      },
      on: {
        "change": function ($event) {
          _vm.updateField(Object.keys(filterField)[0], $event);
        },
        "clear": function ($event) {
          return _vm.clearQuery(index);
        }
      }
    });
  }), 1) : _vm._e();
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$d = function (inject) {
  if (!inject) return;
  inject("data-v-8f284982_0", {
    source: ".simple-filter__item+.simple-filter__item[data-v-8f284982]{margin-left:1rem}.simple--filter[data-v-8f284982]{display:flex;flex-direction:row;flex-wrap:inherit;align-items:baseline;width:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$d = "data-v-8f284982";
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

var SimpleFilter = __vue_component__$d;

var script$c = Vue.extend({
  name: "table-options",
  components: {
    "el-checkbox": Checkbox,
    "el-checkbox-group": CheckboxGroup
  },
  watch: {
    checkAll(checkAllVal) {
      this.selectedColumns = checkAllVal ? this.getTableColumns : [this.getTableColumns[0]];
      this.SET_ACTIVE_TABLE_COLUMNS(this.selectedColumns);
    }

  },
  methods: { ...listViewModuleMapMutations(["SET_ACTIVE_TABLE_COLUMNS"]),

    selectedColumnsUpdated(checkedItems) {
      let checkedCount = checkedItems.length;
      this.checkAll = checkedCount === this.getTableColumns.length;
      this.SET_ACTIVE_TABLE_COLUMNS(this.selectedColumns);
    }

  },

  data() {
    return {
      checkAll: false,
      isIndeterminate: true,
      selectedColumns: [],
      lastColumn: []
    };
  },

  created() {
    this.selectedColumns = this.getActiveTableColumns;
  },

  computed: { ...listViewModuleMapState(["listViewStoreReady", "tableColumnRules"]),
    ...listViewModuleMapGetters(["getTableColumns", "getActiveTableColumns"])
  }
});

/* script */
const __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.listViewStoreReady ? _c('div', [_c('div', {
    staticClass: "flex flex-col py-4"
  }, [_c('el-checkbox-group', {
    staticClass: "flex flex-wrap flex-row",
    attrs: {
      "min": 1
    },
    on: {
      "change": _vm.selectedColumnsUpdated
    },
    model: {
      value: _vm.selectedColumns,
      callback: function ($$v) {
        _vm.selectedColumns = $$v;
      },
      expression: "selectedColumns"
    }
  }, _vm._l(_vm.getTableColumns, function (item, index) {
    return _c('el-checkbox', {
      key: item + "-" + index,
      staticClass: "w-1/2 mr-0",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(_vm.tableColumnRules[item].formatDataKey || item))]);
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs",
    on: {
      "click": function ($event) {
        _vm.checkAll = !_vm.checkAll;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.checkAll ? "uncheck all" : "check all") + "\n  ")])]) : _vm._e();
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$c = undefined;
/* scoped */

const __vue_scope_id__$c = undefined;
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

var TableOptions = __vue_component__$c;

var script$b = Vue.extend({
  computed: { ...listViewModuleMapState(["listViewStoreReady", "totalTableRecords", "tableRecordsPerPageCount"])
  }
});

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.totalTableRecords && _vm.listViewStoreReady ? _c('div', {
    staticClass: "text-gray-500 text-xs select-none"
  }, [_vm._v("\n  Showing " + _vm._s(_vm.tableRecordsPerPageCount) + " of\n  " + _vm._s(_vm.totalTableRecords >= _vm.tableRecordsPerPageCount ? _vm.totalTableRecords : _vm.tableRecordsPerPageCount) + "\n")]) : _vm._e();
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = undefined;
/* scoped */

const __vue_scope_id__$b = "data-v-61834ee0";
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var TableStatus = __vue_component__$b;

var script$a = Vue.extend({
  props: {
    columnKey: {
      type: String,
      default: ""
    },
    column: {
      type: Object,

      default() {
        return {};
      }

    },
    row: {
      type: Object,

      default() {
        return {};
      }

    }
  },
  computed: {
    valueFormatted() {
      const {
        formatDataValue
      } = this.column;
      const value = get(this.row, this.columnKey);
      const formatted = formatDataValue(value, this.row);
      return formatted;
    },

    valueComponent() {
      const {
        formatDataComponent
      } = this.column;
      return formatDataComponent;
    },

    isVueComponent() {
      const {
        formatDataComponent
      } = this.column;
      return !!formatDataComponent;
    }

  }
});

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.isVueComponent ? _c(_vm.valueComponent, {
    tag: "component",
    attrs: {
      "valueFormatted": _vm.valueFormatted,
      "columnKey": _vm.columnKey,
      "column": _vm.column,
      "row": _vm.row
    }
  }) : _c('span', {
    staticClass: "break-normal",
    domProps: {
      "innerHTML": _vm._s(_vm.valueFormatted)
    }
  });
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = undefined;
/* scoped */

const __vue_scope_id__$a = undefined;
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

var script$9 = Vue.extend({
  components: {
    INFButton
  },
  props: {
    tableActions: {
      type: Array,

      default() {
        return [];
      }

    },
    tableRowActions: {
      type: Array,
      default: () => []
    },
    operationsComponent: {
      type: [Object, Function],

      default() {
        return {};
      }

    },
    row: {
      type: Object,

      default() {
        return {};
      }

    }
  }
});

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return !!_vm.operationsComponent ? _c('div', [_c(typeof _vm.operationsComponent === "function" ? _vm.operationsComponent() : _vm.operationsComponent, {
    tag: "component",
    attrs: {
      "row": _vm.row,
      "tableRowActions": _vm.tableRowActions
    },
    on: {
      "emitEvent": function ($event) {
        return _vm.$emit('emitEvent', $event);
      },
      "table-row-action": function ($event) {
        return _vm.$emit('table-row-action', $event);
      }
    }
  })], 1) : _vm._e();
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = undefined;
/* scoped */

const __vue_scope_id__$9 = undefined;
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

var script$8 = Vue.extend({
  name: "TableRowActions",
  components: {
    "el-dropdown": Dropdown,
    "el-dropdown-menu": DropdownMenu,
    "el-dropdown-item": DropdownItem,
    "el-button": Button,
    "el-tag": Tag,
    "font-awesome-icon": FontAwesomeIcon
  },
  props: {
    tableRowActions: {
      type: Array,
      required: false,
      default: () => []
    },
    row: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    truncate,

    getPotentiallyFunctionalValue(option, key) {
      if (option[key]) {
        if (typeof option[key] === "string") {
          return option[key];
        }

        if (typeof option[key] === "function") {
          return option[key](this.row);
        }
      } else {
        return undefined;
      }
    }

  },
  computed: {
    filteredActions() {
      const actions = [];

      for (const action of this.tableRowActions) {
        if (action.show && typeof action.show === "function") {
          if (action.show(this.row)) {
            actions.push(action);
          }
        } else {
          actions.push(action);
        }
      }

      return actions;
    }

  }
});

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "flex items-center px-2 justify-center"
  }, [_c('el-dropdown', {
    staticClass: "mr-4",
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "command": function ($event) {
        return _vm.$emit('table-row-action', {
          name: $event,
          data: _vm.row
        });
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-more-outline"
  }), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.filteredActions, function (option, index) {
    return _c('el-dropdown-item', {
      key: index,
      staticClass: "w-36",
      class: option.class,
      attrs: {
        "command": option.value,
        "icon": option.icon
      }
    }, [_c('div', {
      staticClass: "item__label"
    }, [option.faIcon ? _c('font-awesome-icon', {
      staticStyle: {
        "margin-right": "2px"
      },
      attrs: {
        "icon": ['fal', _vm.getPotentiallyFunctionalValue(option, 'faIcon')]
      }
    }) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.truncate(_vm.getPotentiallyFunctionalValue(option, 'label'), {
      length: 20
    })) + "\n        ")], 1), _vm._v(" "), option.subLabel ? _c('div', [_vm._v(_vm._s(_vm.truncate(option.subLabel, {
      length: 40
    })))]) : _vm._e()]);
  }), 1)], 1)], 1);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-a994df0c_0", {
    source: ".item__label[data-v-a994df0c]{overflow:hidden;text-overflow:ellipsis}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$8 = "data-v-a994df0c";
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);

var TableRowActions = __vue_component__$8;

const allowedTableSzies = ["medium", "small", "mini"];
var script$7 = Vue.extend({
  name: "table-wrapper",
  components: {
    TableColumnCell: __vue_component__$a,
    TableColumnOperations: __vue_component__$9,
    "el-table": Table,
    "el-table-column": TableColumn,
    TableRowActions
  },
  props: {
    fetchingData: {
      type: Boolean,
      default: false
    },
    //Table Properties
    stripe: {
      //whether Table is striped
      type: Boolean,
      default: false
    },
    border: {
      //whether Table has vertical border
      type: Boolean,
      default: true
    },
    size: {
      //size of table
      type: String,
      default: "medium",
      validator: val => allowedTableSzies.includes(val)
    },
    fit: {
      //whether width of column automatically fits its container
      type: Boolean,
      default: true
    },
    showTableHeader: {
      //whether show table headers
      type: Boolean,
      default: true
    },
    expandDataNode: {
      type: Function,
      required: false
    },
    defaultExpandAll: {
      type: Boolean,
      required: false,
      default: false
    },
    operationsComponent: {
      type: [Function, Object],
      required: false
    },
    rowClassNameFn: {
      type: Function,
      required: false,
      default: () => {}
    },
    showSelectable: {
      type: Boolean,
      default: false
    },
    rowSelectableFn: {
      type: Function,
      required: false,
      default: () => true
    },
    tableRowActions: {
      type: Array,
      required: false,
      default: () => []
    },
    rowKey: {
      type: [Function, String],
      required: false
    },
    reserveSelection: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      pageData: []
    };
  },

  computed: { ...listViewModuleMapState(["listViewStoreReady", "tableData", "tableActions"]),
    ...listViewModuleMapState({
      tableColumnRulesFromStore: "tableColumnRules"
    }),

    tableColumnRules() {
      return cloneDeep(this.tableColumnRulesFromStore);
    },

    ...listViewModuleMapGetters(["getActiveTableColumns"]),
    isBoolean: () => value => {
      return isBoolean(value);
    },
    isArray: () => value => {
      return value instanceof Array;
    },

    hasExpandSlot() {
      return !!this.$slots.expand;
    },

    tableHasData() {
      return this.tableData.length > 0;
    },

    hasOperationsComponent() {
      return this.operationsComponent ? true : false;
    },

    hasRowActions() {
      return !!(this.tableRowActions && this.tableRowActions.length > 0);
    },

    getTableColumns() {
      return [...this.getActiveTableColumns].sort((a, b) => this.tableColumnRules[a].position - this.tableColumnRules[b].position);
    }

  },
  methods: {
    cloneDeep,
    ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE"]),

    isSortable(column) {
      if (column.allowSort && column.sortMethod) return true;else if (column.allowSort) return 'custom';else ;
    },

    TableRowActionsComponent() {
      return TableRowActions;
    },

    tableRowClicked(rowData, column, event) {
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "tableRowData",
        value: rowData
      });
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "tableRowDataEvent",
        value: event
      });
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "tableRowDataColumn",
        value: column
      });
      this.$emit("tableRowClicked");
    },

    tableRowDbClicked() {
      this.$emit("tableRowDbClicked");
    },

    lodashGet(dataSource, sourcePath) {
      return get(dataSource, sourcePath);
    }

  }
});

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.listViewStoreReady ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.fetchingData,
      expression: "fetchingData"
    }]
  }, [_vm.tableHasData ? _c('el-table', {
    staticStyle: {
      "overflow-y": "scroll",
      "width": "100%"
    },
    attrs: {
      "data": _vm.cloneDeep(_vm.tableData),
      "stripe": _vm.stripe,
      "border": _vm.border,
      "size": _vm.size,
      "fit": _vm.fit,
      "show-header": _vm.showTableHeader,
      "row-class-name": _vm.rowClassNameFn,
      "default-expand-all": _vm.defaultExpandAll,
      "row-key": _vm.rowKey
    },
    on: {
      "row-click": _vm.tableRowClicked,
      "row-dblclick": _vm.tableRowDbClicked,
      "selection-change": function ($event) {
        return _vm.$emit('selection-change', $event);
      },
      "sort-change": function ($event) {
        return _vm.$emit('sort-change', $event);
      }
    }
  }, [_vm.showSelectable ? _c('el-table-column', {
    attrs: {
      "selectable": _vm.rowSelectableFn,
      "type": "selection",
      "width": "55",
      "reserve-selection": _vm.reserveSelection
    }
  }) : _vm._e(), _vm._v(" "), _vm.expandDataNode ? _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (props) {
        return [_c(_vm.expandDataNode(), {
          tag: "component",
          attrs: {
            "row": props.row
          }
        })];
      }
    }], null, false, 2999467025)
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.getTableColumns, function (column, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "fixed": false,
        "class-name": _vm.tableColumnRules[column].colClassName ? _vm.tableColumnRules[column].colClassName : "",
        "min-width": _vm.tableColumnRules[column].minWidth ? _vm.tableColumnRules[column].minWidth : 180,
        "width": _vm.tableColumnRules[column].colWidth,
        "prop": column,
        "sortable": _vm.isSortable(_vm.tableColumnRules[column]),
        "resizable": true,
        "label": typeof _vm.tableColumnRules[column].formatDataKey === 'string' ? _vm.tableColumnRules[column].formatDataKey : _vm.tableColumnRules[column].formatDataKey(),
        "sort-method": _vm.tableColumnRules[column].sortMethod
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (scope) {
          return [_c('TableColumnCell', {
            attrs: {
              "columnKey": column,
              "column": _vm.tableColumnRules[column],
              "row": scope.row
            }
          })];
        }
      }], null, true)
    });
  }), _vm._v(" "), _vm.hasOperationsComponent || _vm.hasRowActions ? _c('el-table-column', {
    staticClass: "table-operations",
    attrs: {
      "fixed": "right",
      "width": _vm.hasRowActions && !_vm.hasOperationsComponent ? '50' : '110',
      "align": _vm.hasRowActions && !_vm.hasOperationsComponent ? 'center' : undefined
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('TableColumnOperations', {
          attrs: {
            "tableActions": _vm.tableActions,
            "tableRowActions": _vm.tableRowActions,
            "operationsComponent": _vm.operationsComponent || _vm.TableRowActionsComponent,
            "row": scope.row
          },
          on: {
            "emitEvent": function ($event) {
              return _vm.$emit('emitEvent', $event);
            },
            "table-row-action": function ($event) {
              return _vm.$emit('table-row-action', $event);
            }
          }
        })];
      }
    }], null, false, 2334707934)
  }) : _vm._e()], 2) : _vm._e()], 1) : _vm._e();
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = undefined;
/* scoped */

const __vue_scope_id__$7 = undefined;
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

var TableWrapper = __vue_component__$7;

var script$6 = Vue.extend({
  name: "Pagination",
  components: {
    "el-pagination": Pagination$1
  },
  props: {
    showPagination: {
      //show pagination
      type: Boolean,
      default: false
    },
    pagerCount: {
      type: Number,
      default: 8
    }
  },
  watch: {
    showPagination: {
      handler(status) {
        /* istanbul ignore else */
        if (status) {
          this.updateCursorPosition(this.currentPage);
        }
      },

      immediate: true
    }
  },
  methods: { ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE"]),

    paginationPageChanged(pageNumber) {
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "currentPage",
        value: pageNumber
      });
      const page = this.paginationLinks && this.paginationLinks.pages ? this.paginationLinks.pages.find(page => page.page === pageNumber) : null;

      if (page) {
        let queryString = page.url.split("?")[1];
        const queryObject = qs.parse(queryString);
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "filterQuery",
          value: queryObject
        });
      }
    },

    paginationPageSizeChanged(pageSize) {
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "defaultPageSize",
        value: pageSize
      });

      if (!isEmpty(this.$route.query)) {
        let queryObject = this.$route.query;
        queryObject["__limit"] = this.defaultPageSize;
        queryObject["__page"] = 1;
        queryObject["__offset"] = 0;
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "filterQuery",
          value: queryObject
        });
      } else {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "filterQuery",
          value: {
            __limit: this.defaultPageSize
          }
        });
      }
    },

    updateCursorPosition(pageNumber) {
      let cursor = this.defaultPageSize * pageNumber;

      if (this.defaultPageSize > this.tableData.length) {
        const diff = this.defaultPageSize - this.tableData.length;
        cursor = cursor - diff;
      }

      this.SET_LIST_VIEW_MODULE_STATE({
        key: "tableRecordsPerPageCount",
        value: cursor
      });
    }

  },
  computed: { ...listViewModuleMapState(["listViewStoreReady", "tableRecordsPerPageCount", "totalTableRecords", "paginationLinks", "tableData"]),
    ...listViewModuleMapGetters(["currentPage", "paginationPageSizes", "defaultPageSize"]),
    getLayouts: function () {
      let selectedLayouts = [];
      /* istanbul ignore if */

      if (this.totalTableRecords >= this.defaultPageSize) {
        selectedLayouts.push(...["sizes, prev, next, pager, jumper"]);
      } else {
        selectedLayouts.push("total");
      }

      return selectedLayouts;
    }
  }
});

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.listViewStoreReady ? _c('el-pagination', {
    staticClass: "text-gray-500 px-0",
    attrs: {
      "background": true,
      "layout": _vm.getLayouts.join(', '),
      "total": _vm.totalTableRecords,
      "page-size": +_vm.defaultPageSize,
      "pager-count": _vm.pagerCount,
      "page-sizes": _vm.paginationPageSizes,
      "current-page": +_vm.currentPage
    },
    on: {
      "size-change": _vm.paginationPageSizeChanged,
      "current-change": _vm.paginationPageChanged
    }
  }) : _vm._e();
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = undefined;
/* scoped */

const __vue_scope_id__$6 = undefined;
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

var Pagination = __vue_component__$6;

var script$5 = Vue.extend({
  name: "single-filter",
  components: {
    "el-row": Col,
    "el-col": Row,
    INFSelectField,
    "font-awesome-icon": FontAwesomeIcon
  },
  props: {
    size: {
      type: String,
      required: false,
      default: "small"
    },
    iconClass: {
      type: String,
      required: false,
      default: "p-2"
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined
    }
  },

  data() {
    return {
      error: "",
      filter: "",
      run_query: false,
      created: false
    };
  },

  methods: { ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE"]),

    runQuery(value) {
      this.simpleFilterSearch({ ...this.filterQuery,
        [`${this.singleFilter.field}__eq`]: value
      });
    },

    clearSingleFilter() {
      const query = { ...this.filterQuery
      };
      delete query[`${this.singleFilter.field}__eq`];
      this.$router.replace({
        query
      }).catch(() => {}); // this.simpleFilterSearch(query)
    },

    simpleFilterSearch(queryObject) {
      queryObject["__regex"] = true;
      const debounce = throttle(() => {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "filterQuery",
          value: queryObject
        });
      }, 1000);
      debounce();
    }

  },
  computed: { ...listViewModuleMapState(["listViewStoreReady", "defaultPageSize", "singleFilter", "filterQuery"]),

    filterValue() {
      const routeQuery = this.$route ? cloneDeep(this.$route.query) : {};
      const routeQueryKeys = Object.keys(routeQuery);
      const queryField = `${this.singleFilter.field}__eq`;

      if (routeQueryKeys.includes(queryField)) {
        return routeQuery[queryField];
      } else {
        return "";
      }
    },

    placeholderVal() {
      if (this.placeholder) return this.placeholder;else {
        if (this.singleFilter.label) {
          return `Filter by ${this.singleFilter.label}`;
        } else {
          return "Filter by";
        }
      }
    }

  }
});

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.listViewStoreReady ? _c('INFSelectField', {
    attrs: {
      "options": _vm.singleFilter.options,
      "placeholder": _vm.placeholderVal,
      "selected": _vm.filterValue,
      "clearable": true,
      "required": false,
      "fieldGroupClass": "",
      "size": _vm.size
    },
    on: {
      "change": _vm.runQuery,
      "clear": _vm.clearSingleFilter
    },
    scopedSlots: _vm._u([{
      key: "prefix",
      fn: function () {
        return [_c('font-awesome-icon', {
          staticClass: "mt-3 mr-2 block",
          class: _vm.iconClass,
          attrs: {
            "icon": ['fal', 'filter']
          }
        })];
      },
      proxy: true
    }], null, false, 268176306)
  }) : _vm._e();
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = undefined;
/* scoped */

const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

var SingleFilter = __vue_component__$5;

var script$4 = Vue.extend({
  name: "INFListViewSearchBar",
  components: {
    "el-input": Input,
    "font-awesome-icon": FontAwesomeIcon,
    "el-dropdown": Dropdown,
    "el-dropdown-menu": DropdownMenu,
    "el-dropdown-item": DropdownItem,
    "el-button": Button,
    "el-select": Select
  },
  props: {
    placeholderText: {
      type: String,
      default: "Search"
    },
    searchDisabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: "medium"
    },
    showSuffix: {
      type: Boolean,
      required: false,
      default: true
    },
    iconClass: {
      type: String,
      required: false,
      default: "py-3"
    },
    searchColumnName: {
      type: String,
      required: false,
      default: "All"
    },
    targetedSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    targetedSearchData: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  directives: {
    visible: function (el, binding) {
      el.style.visibility = !!binding.value ? 'visible' : 'hidden';
    }
  },
  watch: {
    clearFieldProp() {
      this.searchValue = "";
      this.clearSearchQuery();
    }

  },

  data() {
    return {
      searchValue: "",
      existingValue: "",
      hasRunSearch: false,
      selectedColumn: ""
    };
  },

  created() {
    const keys = Object.keys(this.$route.query);

    if (keys.includes("__query") && typeof this.$route.query["__query"] === "string") {
      this.searchValue = this.$route.query["__query"];
      this.existingValue = this.$route.query["__query"];
    }
  },

  methods: { ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE"]),

    searchValueChange(searchValue) {
      let minLengthSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (searchValue !== "") {
        const query = {};
        query["__query"] = searchValue;

        if (searchValue.length < 3 && !minLengthSearch || searchValue.length >= 3 && minLengthSearch) {
          this.updateSearchQuery(query);
        }
      } else {
        if (this.existingValue !== "") {
          this.updateSearchQuery({
            __query: ""
          });
        }
      }
    },

    searchSelectedColumValueChange(selectedColumn) {
      if (typeof selectedColumn === "string") {
        const query = {};
        query["__searchSelections"] = selectedColumn;
        this.updateSearchQuery(query);
      }
    },

    searchColumnChanged(command) {
      this.selectedColumn = command;
      this.searchSelectedColumValueChange(command);
    },

    searchInputChange(searchValue) {
      if (searchValue.length >= 3) {
        this.searchValueChange(searchValue, true);
      } else {
        if (searchValue.length === 0) {
          if (this.existingValue) {
            this.updateSearchQuery({
              __query: ""
            });
          }
        }

        if (searchValue.length > 0 && searchValue.length < 3) {
          if (this.existingValue) {
            this.updateSearchQuery({
              __query: searchValue
            });
          }
        }
      }
    },

    clearSearchQuery() {
      this.updateSearchQuery({
        __query: ""
      });
    },

    updateSearchQuery(query) {
      this.existingValue = query.__query ? query.__query : "";
      const debounce = throttle(() => {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "filterQuery",
          value: { ...query,
            __offset: 0
          }
        });
      }, 1000);
      debounce();
    },

    ellipsis(value, length) {
      if (!value) return "";

      if (value.length <= length) {
        return value;
      } //cut off should be whole words


      const wordSplit = value.split(' ');
      let word = wordSplit[0];

      for (let i = 1; i <= wordSplit.length; i++) {
        if (word.length + wordSplit[i].length + 1 < length) {
          word = word + " " + wordSplit[i];
        } else {
          return word + "...";
        }
      }

      return word + "...";
    }

  },
  computed: { ...listViewModuleMapState(["listViewStoreReady"]),

    selectedColumnName() {
      const cols = this.targetedSearchData.find(column => column.value === this.selectedColumn);
      return cols ? this.ellipsis(cols.key, 15) : this.searchColumnName;
    }

  }
});

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.listViewStoreReady ? _c('el-input', {
    staticClass: "table-search",
    staticStyle: {
      "min-width": "180px",
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.placeholderText,
      "clearable": true,
      "disabled": _vm.searchDisabled,
      "size": _vm.size,
      "suffix-icon": "el-icon-search"
    },
    on: {
      "input": _vm.searchInputChange,
      "change": _vm.searchValueChange,
      "clear": _vm.clearSearchQuery
    },
    model: {
      value: _vm.searchValue,
      callback: function ($$v) {
        _vm.searchValue = $$v;
      },
      expression: "searchValue"
    }
  }, [_vm.targetedSearch ? _c('el-dropdown', {
    staticClass: " flex justify-center items-center",
    attrs: {
      "slot": "prepend",
      "hide-on-click": false,
      "placement": "bottom-start"
    },
    on: {
      "command": _vm.searchColumnChanged
    },
    slot: "prepend"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.selectedColumnName) + " ")]), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.targetedSearchData, function (column, index) {
    return _c('el-dropdown-item', {
      key: index,
      staticClass: "pl-2 pr-4",
      attrs: {
        "command": column.value
      }
    }, [_c('i', {
      directives: [{
        name: "visible",
        rawName: "v-visible",
        value: _vm.selectedColumn === column.value,
        expression: "selectedColumn===column.value"
      }],
      staticClass: "el-icon-check "
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(column.key))])]);
  }), 1)], 1) : _vm._e()], 1) : _vm._e();
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-8fac352e_0", {
    source: ".table-search .el-input-group__prepend{padding:0 5px!important}@media only screen and (max-width:425px){.table-search{display:flex!important;flex-direction:column}.table-search .el-input-group__prepend{width:94%!important;padding:7px 5px!important;margin-bottom:2px!important;border:1px solid #dcdfe6!important;border-radius:4px!important}.table-search .el-input__suffix{top:20px!important}.table-search input{border:1px solid #dcdfe6!important;border-radius:4px!important}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = undefined;
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

var ListViewSearchBar = __vue_component__$4;

var script$3 = Vue.extend({
  name: "new-filter",
  components: {
    "el-dropdown": Dropdown,
    "el-dropdown-menu": DropdownMenu,
    "el-dropdown-item": DropdownItem,
    "el-button": Button,
    "el-tag": Tag
  },
  props: {
    filter: {
      type: Object,
      //should have title and options --> {[k]:v}[]
      required: true,
      default: () => ({})
    },
    size: {
      type: String,
      required: false,
      default: "medium"
    }
  },
  methods: { ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE"]),

    runQuery(value) {
      if (this.filterValue) {
        if (this.filterValue === value || this.filterValue.includes(value)) {
          return;
        } else if (this.filter.maxValues && this.filterValues && this.filterValues.length >= this.filter.maxValues) {
          return;
        } else {
          this.simpleFilterSearch({ ...this.filterQuery,
            ...this.$route.query,
            [`${this.filter.field}__in`]: (this.filterValue || "") + `,${value}`
          });
        }
      } else {
        this.simpleFilterSearch({ ...this.filterQuery,
          ...this.$route.query,
          [`${this.filter.field}__in`]: `${value}`
        });
      }
    },

    async clearFilter(value) {
      const fieldKey = `${this.filter.field}__in`;
      const routeQuery = cloneDeep(this.$route.query);

      if (!value) {
        delete routeQuery[fieldKey];
      } else {
        const filterValues = [...this.filterValues].filter(val => val !== value);

        if (filterValues.length === 0) {
          delete routeQuery[fieldKey];
        } else {
          routeQuery[fieldKey] = filterValues.join(",");
        }
      }

      await this.$router.replace({}).catch(() => {});
      await this.$router.replace({
        query: routeQuery
      }).catch(() => {});
      this.simpleFilterSearch(routeQuery);
    },

    simpleFilterSearch(queryObject) {
      queryObject["__regex"] = true;
      const debounce = throttle(() => {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "filterQuery",
          value: queryObject
        });
      }, 1000);
      debounce();
    },

    getValueLabel(value) {
      const option = this.filter.options.find(option => option.value.toString() === value.toString());
      return option ? option.label : value.toString();
    },

    getValueTag(value) {
      return truncate(this.getValueLabel(value), {
        length: 12
      });
    }

  },
  computed: { ...listViewModuleMapState(["listViewStoreReady", "defaultPageSize", "singleFilter", "filterQuery"]),

    filterValue() {
      const routeQuery = this.$route ? cloneDeep(this.$route.query) : {};
      const routeQueryKeys = Object.keys(routeQuery);
      const queryField = `${this.filter.field}__in`;

      if (routeQueryKeys.includes(queryField)) {
        return routeQuery[queryField];
      } else {
        return "";
      }
    },

    filterValues() {
      return this.filterValue.split(",").filter(val => val && val.trim().length > 0).map(val => val.trim());
    },

    active() {
      return !!(this.filterValue && this.filterValue.length > 0);
    },

    formattedFilterValue() {
      const values = this.filterValues;
      const value = values[0];
      const option = this.filter.options.find(option => option.value.toString() === value.toString());
      return option.label || this.filterValue.toString();
    },

    truncatedFormattedFilterValue() {
      return truncate(this.formattedFilterValue, {
        length: 12
      });
    }

  },
  watch: {
    active: {
      handler(active) {
        this.$emit("filter-item-activated", {
          key: this.filter.field,
          active
        });
      },

      immediate: true
    },
    'filter.defaultOptions.initialValue': {
      handler(value) {
        if (typeof value !== 'undefined' && value !== "") {
          this.runQuery(value);
        }
      },

      immediate: true
    }
  }
});

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "filter-button flex items-center px-2",
    class: {
      active: _vm.active
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "type": "primary"
    },
    on: {
      "command": _vm.runQuery
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": 'mini'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.filter.title)), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  }), _vm._v(" "), _vm.active ? _c('span', {
    staticClass: "space-x-2"
  }, _vm._l(_vm.filterValues, function (value, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "closable": "",
        "size": "small",
        "title": _vm.getValueLabel(value),
        "disable-transitions": true
      },
      on: {
        "close": function ($event) {
          return _vm.clearFilter(value);
        }
      }
    }, [_vm._v(_vm._s(_vm.getValueTag(value)))]);
  }), 1) : _vm._e()]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.filter.options, function (option, index) {
    return _c('el-dropdown-item', {
      key: index,
      staticClass: "py-2",
      attrs: {
        "disabled": _vm.filterValue.includes(option.value),
        "command": option.value
      }
    }, [_c('p', {
      staticClass: "item__label"
    }, [_vm._v(_vm._s(option.label))]), _vm._v(" "), option.subLabel ? _c('small', {
      staticClass: "item__help"
    }, [_vm._v(_vm._s(option.subLabel))]) : _vm._e()]);
  }), 1)], 1)], 1);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-36224be7_0", {
    source: ".close-icon[data-v-36224be7]{color:#66b1ff;cursor:pointer}.item__help[data-v-36224be7]{cursor:pointer;display:block;margin-top:-25px;white-space:normal;word-wrap:break-word;color:#516f90!important}.item__label[data-v-36224be7]{overflow:hidden;text-overflow:ellipsis;color:#33475b;font-size:15px}.el-dropdown-menu__item.is-disabled[data-v-36224be7]{cursor:default;color:#f21b1b;pointer-events:none;background-color:#e6eef6}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$3 = "data-v-36224be7";
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

var script$2 = Vue.extend({
  name: "date-filter-item",
  components: {
    "el-popover": Popover,
    "el-button": Button,
    "el-radio": Radio,
    INFDatePicker
  },
  props: {
    filter: {
      type: Object,
      required: true,
      default: () => ({})
    },
    size: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      __lte: null,
      __gte: null
    };
  },

  mounted() {
    if (this.filter.defaultOptions && this.filter.defaultOptions.defaultFilter) {
      const {
        defaultFilter
      } = this.filter.defaultOptions;

      if (["is between", "is after", "is before"].includes(defaultFilter)) {
        setTimeout(() => this.dateFilterChanged(defaultFilter), Math.random() * Math.random() * 1256);
      }
    }
  },

  methods: { ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE"]),
    ...listViewModuleMapState(["listViewStoreReady", "defaultPageSize", "singleFilter", "filterQuery"]),

    simpleFilterSearch(queryObject) {
      if (this.hasValidDataForQuery(queryObject)) {
        this.makeSearch(queryObject);
      }
    },

    makeSearch(queryObject) {
      queryObject["__regex"] = true;
      const debounce = throttle(() => {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "filterQuery",
          value: queryObject
        });
      }, 1000);
      debounce();
    },

    async runBetweenDateQuery(payload) {
      const {
        key,
        value
      } = payload;
      this[key] = value;
      let {
        __lte = this.defaultEndDate,
        __gte = this.defaultStartDate
      } = this;
      __lte = set$1(__lte, {
        hours: 23,
        minutes: 59,
        seconds: 59,
        milliseconds: 59
      });
      __gte = set$1(__gte, {
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
      });

      if (!(value instanceof Date)) {
        const __lteIsInvalid = !__lte || !this.dateIsValid(__lte);

        const __gteIsInvalid = !__gte || !this.dateIsValid(__gte);

        if (__lteIsInvalid && __gteIsInvalid) {
          const query = { ...this.filterQuery,
            ...this.$route.query
          };
          delete query[`${this.filter.field}__lte`];
          delete query[`${this.filter.field}__gte`];
          await this.$router.replace({}).catch(() => {});
          await this.$router.replace({
            query
          }).catch(() => {});
          this.makeSearch(query);
        }
      } else {
        if (__lte && __gte && this.dateIsValid(__lte) && this.dateIsValid(__gte)) {
          const query = { ...this.filterQuery,
            ...this.$route.query,
            [`${this.filter.field}__lte`]: format(__lte, "MM/dd/yyyy HH:mm:ss"),
            [`${this.filter.field}__gte`]: format(__gte, "MM/dd/yyyy HH:mm:ss")
          };
          await this.$router.replace({}).catch(() => {});
          await this.$router.replace({
            query
          }).catch(() => {});
          this.simpleFilterSearch(query);
        }
      }
    },

    async runStartDateQuery(value) {
      if (!(value instanceof Date)) {
        const query = { ...this.filterQuery,
          ...this.$route.query
        };
        delete query[`${this.filter.field}__gte`];
        await this.$router.replace({}).catch(() => {});
        await this.$router.replace({
          query
        }).catch(() => {});
        this.simpleFilterSearch(query);
      } else {
        value = set$1(value, {
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });
        const query = { ...this.filterQuery,
          ...this.$route.query,
          [`${this.filter.field}__gte`]: format(value, "MM/dd/yyyy HH:mm:ss")
        };
        await this.$router.replace({}).catch(() => {});
        await this.$router.replace({
          query
        }).catch(() => {});
        this.simpleFilterSearch(query);
      }
    },

    async runEndDateQuery(value) {
      if (!(value instanceof Date)) {
        const query = { ...this.filterQuery,
          ...this.$route.query
        };
        delete query[`${this.filter.field}__lte`];
        await this.$router.replace({}).catch(() => {});
        await this.$router.replace({
          query
        }).catch(() => {});
        this.simpleFilterSearch(query);
      } else {
        value = set$1(value, {
          hours: 23,
          minutes: 59,
          seconds: 59,
          milliseconds: 59
        });
        const query = { ...this.filterQuery,
          ...this.$route.query,
          [`${this.filter.field}__lte`]: format(value, "MM/dd/yyyy HH:mm:ss")
        };
        await this.$router.replace({}).catch(() => {});
        await this.$router.replace({
          query
        }).catch(() => {});
        this.simpleFilterSearch(query);
      }
    },

    async clearFilter() {
      const query = { ...this.$route.query,
        ...this.filterQuery
      };
      const hasValidQueryData = this.hasValidDataForQuery(query);
      delete query[`${this.filter.field}__gte`];
      delete query[`${this.filter.field}__lte`];
      delete query[`${this.filter.field}_dateFilter`];
      await this.$router.replace({}).catch(() => {});
      await this.$router.replace({
        query
      }).catch(() => {});

      if (hasValidQueryData) {
        this.makeSearch(query);
      }
    },

    getFilterDefaultQuery(currentQuery, dateFilter) {
      const {
        formattedDefaultStartDate,
        formattedDefaultEndDate
      } = this;

      if (dateFilter === "is between") {
        if (formattedDefaultStartDate && formattedDefaultEndDate) {
          currentQuery[`${this.filter.field}__gte`] = formattedDefaultStartDate;
          currentQuery[`${this.filter.field}__lte`] = formattedDefaultEndDate;
        }
      }

      if (dateFilter === "is after") {
        if (formattedDefaultStartDate) {
          currentQuery[`${this.filter.field}__gte`] = formattedDefaultStartDate;
          delete currentQuery[`${this.filter.field}__lte`];
        }
      }

      if (dateFilter === "is before") {
        if (formattedDefaultEndDate) {
          currentQuery[`${this.filter.field}__lte`] = formattedDefaultEndDate;
          delete currentQuery[`${this.filter.field}__gte`];
        }
      }

      if (!["is before", "is after", "is between"].includes(dateFilter)) {
        delete currentQuery[`${this.filter.field}__gte`];
        delete currentQuery[`${this.filter.field}__lte`];
      }

      return currentQuery;
    },

    async dateFilterChanged(dateFilter) {
      const initialQuery = { ...this.$route.query,
        ...this.filterQuery,
        [`${this.filter.field}_dateFilter`]: dateFilter
      };
      const query = this.getFilterDefaultQuery(initialQuery, dateFilter);
      await this.$router.replace({}).catch(() => {});
      await this.$router.replace({
        query
      }).catch(() => {});
      this.simpleFilterSearch(query);
    },

    getStartDate(queryObject) {
      const routeQueryKeys = Object.keys(queryObject);
      const queryField = `${this.filter.field}__gte`;

      if (routeQueryKeys.includes(queryField)) {
        return queryObject[queryField];
      }

      return "";
    },

    getEndDate(queryObject) {
      const routeQueryKeys = Object.keys(queryObject);
      const queryField = `${this.filter.field}__lte`;

      if (routeQueryKeys.includes(queryField)) {
        return queryObject[queryField];
      }

      return "";
    },

    dateIsValid(date) {
      return !!(date && !isNaN(new Date(date).getTime()));
    },

    hasValidDataForQuery(queryObject) {
      const startDateIsValid = this.dateIsValid(this.getStartDate(queryObject));
      const endDateIsValid = this.dateIsValid(this.getEndDate(queryObject));

      if (startDateIsValid || endDateIsValid) {
        if (this.dateFilter) {
          if (this.dateFilter === "is after") {
            return startDateIsValid;
          }

          if (this.dateFilter === "is before") {
            return endDateIsValid;
          }

          if (this.dateFilter === "is between") {
            return startDateIsValid && endDateIsValid;
          }
        }
      }

      return false;
    }

  },
  computed: {
    filterValue() {
      const routeQuery = this.$route ? cloneDeep(this.$route.query) : {};
      const routeQueryKeys = Object.keys(routeQuery);
      const queryField = `${this.filter.field}__in`;

      if (routeQueryKeys.includes(queryField)) {
        return routeQuery[queryField];
      } else {
        return "";
      }
    },

    dateFilter() {
      const routeQuery = this.$route ? cloneDeep(this.$route.query) : {};
      const filterField = `${this.filter.field}_dateFilter`;
      return routeQuery[filterField];
    },

    active() {
      return !!(this.dateFilter || !!(this.startDate__gte || this.endDate__lte));
    },

    startDate__gte() {
      const routeQuery = this.$route ? cloneDeep(this.$route.query) : {};
      const routeQueryKeys = Object.keys(routeQuery);
      const queryField = `${this.filter.field}__gte`;

      if (routeQueryKeys.includes(queryField)) {
        return routeQuery[queryField];
      }

      return "";
    },

    endDate__lte() {
      const routeQuery = this.$route ? cloneDeep(this.$route.query) : {};
      const routeQueryKeys = Object.keys(routeQuery);
      const queryField = `${this.filter.field}__lte`;

      if (routeQueryKeys.includes(queryField)) {
        return routeQuery[queryField];
      }

      return "";
    },

    defaultStartDate() {
      let date = get(this, 'filter.defaultOptions.startDate');

      if (date) {
        date = set$1(date, {
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });
        return date || null;
      }

      return null;
    },

    defaultEndDate() {
      let date = get(this, 'filter.defaultOptions.endDate');

      if (date) {
        date = set$1(date, {
          hours: 23,
          minutes: 59,
          seconds: 59,
          milliseconds: 59
        });
        return date || null;
      }

      return null;
    },

    formattedDefaultStartDate() {
      if (this.defaultStartDate) {
        return format(this.defaultStartDate, "MM/dd/yyyy");
      }

      return null;
    },

    formattedDefaultEndDate() {
      if (this.defaultEndDate) {
        return format(this.defaultEndDate, "MM/dd/yyyy");
      }

      return null;
    },

    formattedStartDate() {
      if (this.startDate__gte && this.dateIsValid(this.startDate__gte)) {
        return format(new Date(this.startDate__gte), "MM/dd/yyyy");
      } else if (this.defaultStartDate && this.dateIsValid(this.defaultStartDate)) {
        return format(this.defaultStartDate, "MM/dd/yyyy");
      }

      return "";
    },

    formattedEndDate() {
      if (this.endDate__lte && this.dateIsValid(this.endDate__lte)) {
        return format(new Date(this.endDate__lte), "MM/dd/yyyy");
      } else if (this.defaultEndDate && this.dateIsValid(this.defaultEndDate)) {
        return format(this.defaultEndDate, "MM/dd/yyyy");
      }

      return "";
    },

    formattedValue() {
      if (this.dateFilter) {
        switch (this.dateFilter) {
          case "is after":
            return !!this.formattedStartDate ? `after ${this.formattedStartDate}` : "";

          case "is before":
            return !!this.formattedEndDate ? `before ${this.formattedEndDate}` : "";

          case "is between":
            return !!(this.formattedStartDate && this.formattedEndDate) ? `${this.formattedStartDate} to ${this.formattedEndDate}` : "";

          default:
            return "";
        }
      }

      return "";
    }

  },
  watch: {
    active: {
      handler(active) {
        this.$emit("filter-item-activated", {
          key: this.filter.field,
          active
        });
      },

      immediate: true
    }
  }
});

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "filter-button flex sm:items-center px-2 h-full sm:justify-center",
    class: {
      active: _vm.active
    }
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "click"
    },
    scopedSlots: _vm._u([{
      key: "reference",
      fn: function () {
        return [_c('span', {
          staticClass: "flex"
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": 'mini'
          }
        }, [_vm._v("\n          " + _vm._s(_vm.filter.title)), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        }), _vm._v(" "), _vm.active && _vm.formattedValue ? _c('span', [_c('span', {
          staticStyle: {
            "font-size": "10px"
          },
          attrs: {
            "closable": "",
            "size": "small",
            "title": _vm.formattedValue
          }
        }, [_vm._v(_vm._s(_vm.formattedValue))])]) : _vm._e()])], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-4"
  }, [_c('div', [_c('el-radio', {
    staticClass: "item__label",
    attrs: {
      "value": _vm.dateFilter,
      "label": "is between",
      "size": "medium"
    },
    on: {
      "input": _vm.dateFilterChanged
    }
  }), _vm._v(" "), _vm.dateFilter === 'is between' ? _c('div', {
    staticClass: "my-4"
  }, [_c('INFDatePicker', {
    attrs: {
      "clearable": true,
      "type": "date",
      "pickerOptions": {},
      "value": _vm.startDate__gte || _vm.defaultStartDate
    },
    on: {
      "change": function ($event) {
        return _vm.runBetweenDateQuery({
          key: '__gte',
          value: $event
        });
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-2"
  }, [_vm._v("and")]), _vm._v(" "), _c('INFDatePicker', {
    attrs: {
      "clearable": true,
      "type": "date",
      "pickerOptions": {},
      "value": _vm.endDate__lte || _vm.defaultEndDate
    },
    on: {
      "change": function ($event) {
        return _vm.runBetweenDateQuery({
          key: '__lte',
          value: $event
        });
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "my-4",
    attrs: {
      "id": "is after"
    }
  }, [_c('el-radio', {
    staticClass: "item__label",
    attrs: {
      "value": _vm.dateFilter,
      "label": "is after"
    },
    on: {
      "input": _vm.dateFilterChanged
    }
  }), _vm._v(" "), _vm.dateFilter === 'is after' ? _c('div', {
    staticClass: "my-4"
  }, [_c('INFDatePicker', {
    ref: "afterStartDatePicker",
    attrs: {
      "clearable": true,
      "type": "date",
      "pickerOptions": {},
      "value": _vm.startDate__gte || _vm.defaultStartDate
    },
    on: {
      "change": _vm.runStartDateQuery
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "is before"
    }
  }, [_c('el-radio', {
    staticClass: "item__label",
    attrs: {
      "value": _vm.dateFilter,
      "label": "is before"
    },
    on: {
      "input": _vm.dateFilterChanged
    }
  }), _vm._v(" "), _vm.dateFilter === 'is before' ? _c('div', {
    staticClass: "my-4"
  }, [_c('INFDatePicker', {
    ref: "beforeEndDatePicker",
    attrs: {
      "type": "date",
      "clearable": true,
      "pickerOptions": {},
      "value": _vm.endDate__lte || _vm.defaultEndDate
    },
    on: {
      "change": _vm.runEndDateQuery
    }
  })], 1) : _vm._e()], 1)])]), _vm._v(" "), _vm.active ? _c('el-button', {
    staticClass: "text-red-400",
    attrs: {
      "type": "text",
      "size": _vm.size,
      "icon": "el-icon-close el-icon--right"
    },
    on: {
      "click": _vm.clearFilter
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-37f747ae_0", {
    source: ".item__label[data-v-37f747ae]{overflow:hidden;text-overflow:ellipsis;color:#33475b;font-size:15px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$2 = "data-v-37f747ae";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

var DateFilterItem = __vue_component__$2;

var script$1 = Vue.extend({
  name: "FilterItemsManager",
  components: {
    FilterItem: __vue_component__$3,
    "el-button": Button,
    DateFilterItem
  },
  props: {
    filters: {
      type: Array,
      required: false,
      default: () => []
    },
    size: {
      type: String,
      required: false,
      default: "medium"
    }
  },

  data() {
    return {
      activeFilters: new Set()
    };
  },

  methods: {
    filterItemActivatedHandler(_ref) {
      let {
        key,
        active
      } = _ref;
      if (active) this.activeFilters.add(key);else this.activeFilters.delete(key);
      this.activeFilters = cloneDeep(this.activeFilters); //Set was not(didn't seem to be) reactive. This is a hack. Tread carefully
    },

    async clearAllFilters() {
      for (const filter of this.filters) {
        const filterRef = this.$refs[filter.field][0];

        if (filter && filterRef) {
          if (filterRef.clearFilter) {
            await filterRef.clearFilter();
          }
        }
      }
    }

  },
  computed: {
    allFiltersActive() {
      return this.activeFilters.size === this.filters.length;
    }

  }
});

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "flex sm:space-x-2 items-start sm:items-center flex-wrap flex-col sm:flex-row"
  }, [_vm._l(_vm.filters, function (filter, index) {
    return _c('div', {
      key: index
    }, [!filter.isDate ? _c('FilterItem', {
      ref: "" + filter.field,
      refInFor: true,
      attrs: {
        "filter": filter,
        "size": _vm.size
      },
      on: {
        "filter-item-activated": _vm.filterItemActivatedHandler
      }
    }) : _c('DateFilterItem', {
      ref: "" + filter.field,
      refInFor: true,
      attrs: {
        "size": _vm.size,
        "filter": filter
      },
      on: {
        "filter-item-activated": _vm.filterItemActivatedHandler
      }
    })], 1);
  }), _vm._v(" "), _vm.activeFilters.size > 1 && _vm.filters.length > 0 ? _c('el-button', {
    attrs: {
      "type": "text",
      "size": 'mini'
    },
    on: {
      "click": _vm.clearAllFilters
    }
  }, [_vm._v("\n    Clear All\n  ")]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var FilterItemsManager = __vue_component__$1;

var script = Vue.extend({
  name: "INFListView",
  components: {
    FilterItemsManager,
    "action-links": ActionLinks,
    "toggle-icons": ToggleIcons,
    "advanced-filter": AdvancedFilter,
    "simple-filter": SimpleFilter,
    "single-filter": SingleFilter,
    "table-options": TableOptions,
    "table-status": TableStatus,
    "table-wrapper": TableWrapper,
    pagination: Pagination,
    "el-row": Row,
    "el-col": Col,
    "el-popover": Popover,
    "el-button": Button,
    "font-awesome-icon": FontAwesomeIcon,
    "el-dropdown": Dropdown,
    "el-dropdown-menu": DropdownMenu,
    "el-dropdown-item": DropdownItem,
    SearchBar: ListViewSearchBar
  },
  props: {
    hasSelectedItems: {
      type: Boolean,
      required: false,
      default: false
    },
    bulkActionsMenuTitle: {
      type: String,
      required: false,
      default: "Bulk Actions"
    },
    bulkMenuActions: {
      type: Array,
      required: false,
      default: () => []
    },
    customBulkMenuActions: {
      type: Array,
      required: false,
      default: () => []
    },
    customBulkActionsMenuTitle: {
      type: String,
      required: false,
      default: "Custom Bulk Actions Menu"
    },
    data: {
      // table data
      type: Array,
      required: true
    },
    filterOperations: {
      type: Array,
      default: function () {
        return [{
          value: "__eq",
          label: "Equals"
        }, {
          value: "__ne",
          label: "Not Equals"
        }, {
          value: "__in",
          label: "Includes"
        }, {
          value: "__nin",
          label: "Not Includes"
        }];
      }
    },
    tableColumns: {
      type: Object,
      required: true
    },
    tableActions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    tableRowActions: {
      type: Array,
      required: false,
      default: () => []
    },
    actionLinks: {
      type: Array,
      default: function () {
        return [];
      }
    },
    paginationLinks: {
      //pagination links
      type: Object,
      required: true
    },
    totalRecords: {
      type: Number,
      required: false
    },
    maxQuerySize: {
      type: Number,
      required: false,
      default: 1000
    },
    loading: {
      type: Boolean,
      default: false
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    addAdvancedFilter: {
      type: Boolean,
      default: false
    },
    showSmartFilter: {
      type: Boolean,
      default: false
    },
    expandDataNode: {
      type: Function,
      required: false
    },
    alwaysShowSimpleFilter: {
      // enable this to always show simple filter.
      // simple filter cannot be closed with this set to true
      type: Boolean,
      default: false
    },
    alwaysShowAdvancedFilter: {
      type: Boolean,
      default: false
    },
    alwaysShowTableOptions: {
      type: Boolean,
      default: true
    },
    alwaysShowColumnsSection: {
      type: Boolean,
      default: true
    },
    customComponent: {
      type: Function,
      required: false
    },
    operationsComponent: {
      type: [Function, Object],
      required: false
    },
    hideAllFilters: {
      type: Boolean,
      default: true
    },
    hideSearchBar: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Array,
      default: () => [],
      required: false
    },
    defaultPageSizeNum: {
      type: Number,
      default: 50
    },
    rowClassNameFn: {
      type: Function,
      required: false,
      default: () => {}
    },
    showSelectable: {
      type: Boolean,
      default: false
    },
    rowSelectableFn: {
      type: Function,
      required: false,
      default: () => true
    },
    size: {
      type: String,
      required: false,
      default: "medium"
    },
    singleFilter: {
      type: Object,
      required: false,
      default: () => undefined,
      validator: function (value) {
        if (!value) return true; //TODO: make validation to ensure it has {field: string; label:string; options: {label: string;, value: any}}

        return !!(value.field && value.field.length > 0 && value.label && value.label.length > 0 && value.options && value.options.length > 0);
      }
    },
    singleFilterIconClass: {
      type: String,
      required: false,
      default: "p-2"
    },
    singleFilterPlaceholder: {
      type: String,
      required: false
    },
    stripe: {
      //whether Table is striped
      type: Boolean,
      default: false
    },
    fetchOnMounted: {
      type: Boolean,
      default: true
    },
    rowKey: {
      type: [Function, String],
      required: false
    },
    reserveSelection: {
      type: Boolean,
      required: false,
      default: false
    },
    searchColumnName: {
      type: String,
      required: false,
      default: "Column"
    },
    targetedSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    targetedSearchData: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      headers: [],
      //table headers
      activeHeaders: [],
      //selected table columns by use
      cursor: 0,
      //cursor for pagination,
      loadedHeaders: false,
      tableOptionsVisible: false,
      tableFilterVisible: false,
      tableSimpleFilterVisible: false,
      hideTableSimpleFilter: false,
      defaultExpandAll: false,
      tableKey: 0,
      showingAllRecords: false,
      selectedItemsCount: 0,
      lastTableRowClickedData: {},
      viewWindowSize: "",
      searchFieldVisible: true,
      filtersVisible: true,
      ready: false
    };
  },

  beforeCreate() {
    this.$store.commit("list_view_module/RESET_LIST_VIEW_MODULE_STORE");
  },

  beforeDestroy() {
    const debounced = throttle(this.appHandleResize, 1000);
    window.removeEventListener("resize", debounced);
  },

  created() {
    this.SET_LIST_VIEW_MODULE_STATE({
      key: "listViewStoreReady",
      value: true
    });
    const pageSize = this.$route && this.$route.query["__limit"] ? parseInt(this.$route.query["__limit"]) : this.defaultPageSizeNum;
    this.SET_LIST_VIEW_MODULE_STATE({
      key: "defaultPageSize",
      value: pageSize
    });

    if (this.singleFilter && Object.keys(this.singleFilter).length > 0) {
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "singleFilter",
        value: this.singleFilter
      });
    }

    const debounced = throttle(this.appHandleResize, 1000);
    window.addEventListener("resize", debounced);
    this.appHandleResize({
      target: window
    });
  },

  mounted() {
    if (this.fetchOnMounted) {
      this.fetchPageData({});
    }

    this.$nextTick(() => {
      let queryObject = cloneDeep(this.$route.query);
      const excludedFields = ["__limit", "__offset", "__columns", "__page", "__regex", "__query", "__sort"];
      const arrayOperations = ["__in", "__nin", "__coin", "__swin", "__eqa"];
      const queryFields = [];
      const queryKeys = omit(queryObject, excludedFields);
      const tableColumnRules = Object.keys(cloneDeep(this.tableColumnRules));
      Object.keys(queryKeys).forEach(key => {
        let value = queryObject[key] instanceof Array ? queryObject[key].join(",") : queryObject[key];
        const field = key.split("__")[0];
        const operation = `__${key.split("__")[1]}`;
        /* istanbul ignore else */

        if (arrayOperations.includes(operation)) {
          value = value.split(",");
        }

        if (value && tableColumnRules.includes(field)) {
          queryFields.push({
            field,
            operation,
            value
          });
        }
      });
      /* istanbul ignore else */

      if (queryFields.length) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "activeFilterQueries",
          value: queryFields
        });
      }
    });
  },

  methods: {
    cloneDeep,
    ...listViewModuleMapMutations(["SET_LIST_VIEW_MODULE_STATE", "RESET_LIST_VIEW_MODULE_STORE"]),

    tableRowClickedHandler() {
      const currentEventData = cloneDeep(this.tableRowData);

      if (!isEqual(currentEventData, cloneDeep(this.lastTableRowClickedData))) {
        this.lastTableRowClickedData = currentEventData;

        if (this.tableRowDataColumn && this.tableRowDataColumn.fixed !== "right") {
          this.$emit("tableRowClicked", this.tableRowData, this.tableRowDataColumn, this.tableRowDataEvent);
        }
      }
    },

    selectionChangeHandler(event) {
      this.selectedItemsCount = event.length;
      this.$emit("selection-change", event);
    },

    toggleExpandAllNodes() {
      this.defaultExpandAll = !this.defaultExpandAll;
      this.tableKey = this.tableKey + 1;
    },

    getColumns() {
      if (!this.$route.query["__columns"]) {
        if (this.loadedHeaders) {
          return;
        }

        const receivedColunns = Object.keys(this.tableColumns).filter(column => this.tableColumns[column].allowInTableOptions === true);
        const defaultSelectedColumns = Object.keys(this.tableColumns).filter(column => this.tableColumns[column].visibleByDefault === true);
        const filterFields = Object.keys(this.tableColumns).filter(column => this.tableColumns[column].allowInAdvancedFilter === true);
        const simpleFilterFields = Object.keys(this.tableColumns).filter(column => this.tableColumns[column].allowInSimpleFilter === true).map(column => ({
          [column]: this.tableColumns[column].simpleFilter ? this.tableColumns[column].simpleFilter : []
        }));

        if (simpleFilterFields.length == 0) {
          this.hideTableSimpleFilter = true;
        }

        this.headers = receivedColunns;
        this.activeHeaders = defaultSelectedColumns;
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "advanceFilterFields",
          value: filterFields
        });
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "simpleFilterFields",
          value: simpleFilterFields
        });
        this.loadedHeaders = true;
      } else {
        if (this.loadedHeaders) {
          return;
        }

        const filterFields = Object.keys(this.tableColumns).filter(column => this.tableColumns[column].allowInAdvancedFilter === true);
        const receivedColunns = Object.keys(this.tableColumns).filter(column => this.tableColumns[column].allowInTableOptions === true);
        const simpleFilterFields = Object.keys(this.tableColumns).filter(column => this.tableColumns[column].allowInSimpleFilter === true).map(column => ({
          [column]: this.tableColumns[column].simpleFilter ? this.tableColumns[column].simpleFilter : []
        }));

        if (simpleFilterFields.length == 0) {
          this.hideTableSimpleFilter = true;
        }

        this.SET_LIST_VIEW_MODULE_STATE({
          key: "advanceFilterFields",
          value: filterFields
        });
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "simpleFilterFields",
          value: simpleFilterFields
        });
        this.headers = receivedColunns; // If user loaded page with columns
        // it automatically becomes active columns.
        // but sometimes the columns may have been modified and
        // only few of those should now be allowed to be filtered.
        // therefore we remove those that are no more allowedFilter.

        this.activeHeaders = this.$route.query["__columns"].split(",").filter(column => receivedColunns.includes(column));
        this.loadedHeaders = true;
      }
    },

    async fetchPageData(query) {
      //* merge old queries with new queries
      const newQuery = cloneDeep(query);
      const oldQuery = cloneDeep(this.$route.query);
      Object.keys(newQuery).forEach(key => {
        //! remove keys with empty values, undefined, null, etc... before merging
        if (key === "__limit") return;

        if (!newQuery[key]) {
          //! delete keys from both queries
          delete newQuery[key];
          delete oldQuery[key];
        }
      });
      const queryObject = Object.assign(oldQuery, newQuery);
      const {
        __limit,
        __page,
        __columns
      } = queryObject;

      if (__limit) {
        //since we are now able to set a limit of -1
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "defaultPageSize",
          value: __limit
        });
      } else {
        if (__limit !== 0) {
          this.SET_LIST_VIEW_MODULE_STATE({
            key: "defaultPageSize",
            value: this.defaultPageSizeNum
          });
          queryObject["__limit"] = this.defaultPageSizeNum;
        }
      }

      if (__page) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "currentPage",
          value: __page
        });
      } else {
        queryObject["__page"] = this.currentPage;
      }

      if (!__columns) {
        queryObject["__columns"] = this.activeHeaders;
      }

      if (!isEmpty(this.$route.query)) {
        await this.$router.replace({}).catch(() => {});
      }

      if (this.$route.query != queryObject) {
        const queryString = prepareQueryString(queryObject);
        await this.$router.replace({
          path: `${queryString}`
        }).catch(() => {});
      }

      function prepareQueryString(query) {
        const queryObjKeys = Object.keys(query);
        let queryS = "?";
        queryObjKeys.forEach(key => {
          let value = query[key] instanceof Array ? query[key].join(",") : query[key];
          queryS = queryS + `&${key}=${value}`;
        });
        return queryS;
      }

      this.$emit("fetch-query", queryObject);
    },

    advancedFilterSearch() {
      const query = cloneDeep(this.activeFilterQueries);
      let queryObject = prepareQueryObj(query); //* Enable this to run regex on query value

      queryObject["__regex"] = true; //! Filter and remove queries with empty values
      // const removedFields = query.filter((q:any) => !q.value)
      // .map((q: any) => `${q.field}${q.operation}`)

      this.fetchPageData(queryObject);

      function prepareQueryObj(query) {
        let queryObject = {};
        query.forEach(query => {
          let fieldNameAndQueryOp = `${query.field}${query.operation}`;
          queryObject[fieldNameAndQueryOp] = query.value;
        });
        return queryObject;
      }
    },

    updateCursorPosition(pageNumber) {
      let cursor = this.defaultPageSize * pageNumber;

      if (this.defaultPageSize > this.data.length) {
        const diff = this.defaultPageSize - this.data.length;
        cursor = cursor - diff;
      }

      this.cursor = cursor;
    },

    async updateColumnsUrl(columns) {
      const joinColumns = columns.join(",");
      const queryObject = cloneDeep(this.$route.query);
      queryObject["__columns"] = joinColumns;

      if (this.$route.query["__columns"] != queryObject["__columns"]) {
        if (!isEmpty(this.$route.query)) {
          await this.$router.replace({}).catch(() => {});
        }

        await this.$router.replace({
          query: queryObject
        }).catch(() => {});
      }
    },

    onShowTableFilter(showOrHide) {
      this.tableFilterVisible = showOrHide;
    },

    onShowSimpleFilter(showOrHide) {
      this.tableSimpleFilterVisible = showOrHide;
    },

    onEmitEvent(event) {
      this.$emit("emitEvent", event);
    },

    emitTableRowDbClicked() {
      this.$emit("tableRowDbClicked", this.tableRowData);
    },

    async showAllHandler() {
      this.showingAllRecords = true;
      const query = { ...this.filterQuery,
        ...this.$route.query
      };
      query.__limit = 0;
      query.__offset = 0;
      query.__page = 1;
      await this.fetchPageData(query);
      this.SET_LIST_VIEW_MODULE_STATE({
        key: "defaultPageSize",
        value: this.maxQuerySize
      });
    },

    changeSort(_ref) {
      let {
        order,
        prop
      } = _ref;
      const tableColumn = get(this.tableColumns, prop);

      if (get(tableColumn, "sortMethod")) {
        return;
      }

      const sortObject = get(tableColumn, "sortBy");
      let sortKey = '';

      if (tableColumn && sortObject) {
        sortKey = sortObject[order];
      } else {
        const sortOperation = order === "descending" ? "-" : "";
        sortKey = `${sortOperation}${prop}`;
      }

      const query = { ...this.filterQuery
      };

      if (query.__sort !== sortKey) {
        query.__sort = sortKey;
        this.fetchPageData(query);
      }
    },

    appHandleResize(e) {
      const mobileSize = 800;
      const {
        outerWidth
      } = e.target;

      if (outerWidth <= mobileSize) {
        // mobile
        this.searchFieldVisible = false;
        this.filtersVisible = false;
        this.viewWindowSize = "sm";
      } else {
        // not mobile
        this.searchFieldVisible = true;
        this.filtersVisible = true;
        this.viewWindowSize = "lg";
      }
    },

    maybeShowSearchField() {
      this.searchFieldVisible = !this.searchFieldVisible;
    },

    maybeShowFilters() {
      this.filtersVisible = !this.filtersVisible;
    }

  },
  computed: { ...listViewModuleMapState(["filterQuery", "activeFilterQueries", "showAdvancedTableFilter", "showSimpleTableFilter", "tableRowData", "tableColumnRules", "tableRowDataColumn", "tableRowDataEvent", "tableData"]),
    ...listViewModuleMapGetters(["getActiveTableColumns", "currentPage", "paginationPageSizes", "defaultPageSize"]),

    tableHasData() {
      return this.tableData.length > 0;
    },

    getTableColumns() {
      const columns = Object.keys(this.tableColumnRules).filter(column => this.tableColumnRules[column].allowSearch);
      return columns;
    },

    hideToggleIcons() {
      // return true
      return !this.alwaysShowSimpleFilter || !this.alwaysShowAdvancedFilter;
    },

    toggleExpandNodeText() {
      return this.defaultExpandAll ? "Collapse All" : "Expand All";
    },

    canQueryAllRecords() {
      return this.totalRecords < this.maxQuerySize;
    },

    canShowAll() {
      const uiCanShowAllAvailableRecords = true; //TODO: set a max on ui?

      const hasMoreToShow = this.totalRecords > this.defaultPageSizeNum;
      return !!(hasMoreToShow && uiCanShowAllAvailableRecords && this.canQueryAllRecords);
    },

    hasActiveFilters() {
      const filtersComponent = this.$refs.filterItemsManager;
      const {
        filterQuery
      } = this;

      if (filterQuery && filtersComponent && filtersComponent['activeFilters']) {
        if (filtersComponent['activeFilters'].size > 0) {
          return true;
        }
      }

      return false;
    }

  },
  watch: {
    filterQuery: {
      handler(query) {
        this.fetchPageData(query);
      },

      deep: true
    },
    data: {
      handler(tableData) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "tableData",
          value: cloneDeep(tableData)
        });
        this.updateCursorPosition(this.currentPage);
      },

      deep: true,
      immediate: true
    },
    filterOperations: {
      handler(queryOperations) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "filterQueryOperations",
          value: queryOperations
        });
      },

      immediate: true,
      deep: true
    },
    tableColumns: {
      handler(rules) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "tableColumnRules",
          value: rules
        });
        this.getColumns();
      },

      immediate: true,
      deep: true
    },
    tableActions: {
      immediate: true,

      handler(actions) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "tableActions",
          value: actions
        });
      }

    },
    actionLinks: {
      immediate: true,

      handler(links) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "actionLinks",
          value: links
        });
      }

    },
    totalRecords: {
      // Watch total records to re-calculate pagination page sizes
      // Increase eachStep value for page sizes ranges
      // ex: 10..20..30 has a step of 10;
      handler(totalRecords) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "totalTableRecords",
          value: totalRecords
        });
        let eachStep = 10;
        let pageSizes = [];

        for (let index = 1; index < totalRecords; index++) {
          let pageSize = index * eachStep;

          if (pageSize > totalRecords) {
            break;
          } else {
            pageSizes.push(pageSize);
          }
        }

        this.SET_LIST_VIEW_MODULE_STATE({
          key: "paginationPageSizes",
          value: pageSizes
        });
      },

      immediate: true
    },
    cursor: {
      handler(cursor) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "tableRecordsPerPageCount",
          value: cursor
        });
      },

      immediate: true
    },
    headers: {
      handler(headers) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "tableColumns",
          value: headers
        });
      },

      immediate: true
    },
    activeHeaders: {
      handler(activeHeaders) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "selectedTableColumns",
          value: activeHeaders
        });
      },

      immediate: true
    },
    getActiveTableColumns: {
      handler(headers) {
        this.updateColumnsUrl(headers);
      },

      immediate: false
    },
    tableRowData: {
      handler() {
        this.tableRowClickedHandler();
      },

      deep: true
    },
    activeFilterQueries: {
      handler() {
        this.advancedFilterSearch();
      },

      deep: true
    },
    paginationLinks: {
      handler(links) {
        this.SET_LIST_VIEW_MODULE_STATE({
          key: "paginationLinks",
          value: links
        });
      },

      deep: true
    }
  }
});

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "components-mb-12"
  }, [_vm._t("header"), _vm._v(" "), _vm.actionLinks.length > 0 ? _c('el-row', [_c('action-links')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "\n      flex\n      flex-row\n      sm:items-center\n      justify-start\n      sm:justify-between\n      w-full\n      py-2\n    ",
    class: {
      'flex-col justify-start': _vm.filtersVisible && _vm.viewWindowSize === 'sm'
    }
  }, [_c('div', {
    staticClass: "flex",
    attrs: {
      "id": "left-list-view-menu"
    }
  }, [!_vm.hideToggleIcons ? _c('toggle-icons', {
    staticClass: "table-icons mr-4",
    attrs: {
      "hideTableSimpleFilterIcon": _vm.hideTableSimpleFilter
    }
  }) : _vm._e(), _vm._v(" "), !_vm.hideToggleIcons && !_vm.hideAllFilters ? _c('div', {
    staticClass: "w-full md:w-3/5"
  }, [_vm.showAdvancedTableFilter && _vm.addAdvancedFilter ? _c('advanced-filter', {
    staticClass: "table-filter-fields",
    attrs: {
      "size": _vm.size
    }
  }) : _vm._e(), _vm._v(" "), _vm.showSimpleTableFilter || _vm.alwaysShowSimpleFilter ? _c('simple-filter', {
    staticClass: "table-filter-fields",
    attrs: {
      "size": _vm.size
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start items-center flex-grow"
  }, [!(_vm.filtersVisible && _vm.viewWindowSize === 'sm') ? _c('div', {
    staticClass: "flex justify-center items-center mr-2"
  }, [!_vm.hideSearchBar && _vm.viewWindowSize === 'sm' ? _c('div', {
    staticClass: "h-6 w-6 mr-2",
    on: {
      "click": _vm.maybeShowSearchField
    }
  }, [!_vm.searchFieldVisible ? _c('font-awesome-icon', {
    staticClass: "text-black h-6 w-6",
    attrs: {
      "icon": ['fal', 'search']
    }
  }) : _c('font-awesome-icon', {
    staticClass: "text-black h-6 w-6",
    attrs: {
      "icon": ['fal', 'times']
    }
  })], 1) : _vm._e(), _vm._v(" "), !_vm.hideSearchBar && _vm.searchFieldVisible ? _c('SearchBar', {
    attrs: {
      "searchColumnName": _vm.searchColumnName,
      "targetedSearch": _vm.targetedSearch,
      "targetedSearchData": _vm.targetedSearchData,
      "size": _vm.size
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), !(!_vm.hideSearchBar && _vm.searchFieldVisible && _vm.viewWindowSize === 'sm') ? _c('div', {
    staticClass: "flex justify-center items-start sm:items-center"
  }, [!_vm.hideSearchBar && _vm.viewWindowSize === 'sm' ? _c('div', {
    staticClass: "h-6 w-6 mr-2 relative",
    on: {
      "click": _vm.maybeShowFilters
    }
  }, [!_vm.filtersVisible && _vm.hasActiveFilters ? _c('div', {
    staticClass: "w-2 h-2 bg-red-600 rounded-full absolute -top-1 -right-2"
  }) : _vm._e(), _vm._v(" "), !_vm.filtersVisible ? _c('font-awesome-icon', {
    staticClass: "text-black h-6 w-6",
    attrs: {
      "icon": ['fal', 'filter']
    }
  }) : _c('font-awesome-icon', {
    staticClass: "text-black h-6 w-6",
    attrs: {
      "icon": ['fal', 'times']
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('FilterItemsManager', {
    ref: "filterItemsManager",
    class: {
      hidden: !_vm.filtersVisible
    },
    attrs: {
      "filters": _vm.filters,
      "size": 'medium'
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "\n        flex \n        items-center\n        justify-end\n        space-x-4\n      ",
    attrs: {
      "id": "right-list-view-menu"
    }
  }, [!_vm.loading && !(!_vm.hideSearchBar && _vm.searchFieldVisible && _vm.viewWindowSize === 'sm') && !(_vm.filtersVisible && _vm.viewWindowSize === 'sm') ? _c('div', {
    staticClass: "\n        flex \n        items-center\n        justify-end\n        space-x-4\n      "
  }, [_vm.selectedItemsCount > 0 && _vm.customBulkMenuActions.length > 0 ? _c('div', {
    staticClass: "text-gray-500"
  }, [_vm.selectedItemsCount > 0 && _vm.customBulkMenuActions.length > 0 ? _c('el-dropdown', {
    on: {
      "command": function (event) {
        return _vm.$emit('custom-bulk-action-event', event);
      }
    }
  }, [_c('el-button', {
    staticClass: "px-2 font-medium",
    staticStyle: {
      "background-color": "#E6EEF6"
    },
    attrs: {
      "type": "text",
      "size": _vm.size
    }
  }, [_vm._v("\n              " + _vm._s(_vm.customBulkActionsMenuTitle)), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right",
    staticStyle: {
      "font-size": "12px"
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', _vm._l(_vm.customBulkMenuActions, function (item, index) {
    return _c('el-dropdown-item', {
      key: index,
      staticClass: "cursor-pointer el-dropdown-item",
      attrs: {
        "command": item.title,
        "disabled": item.disabled
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")]);
  }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.selectedItemsCount > 0 && _vm.bulkMenuActions.length > 0 ? _c('div', {
    staticClass: "text-gray-500 mr-4"
  }, [_vm.selectedItemsCount > 0 && _vm.bulkMenuActions.length > 0 ? _c('el-dropdown', {
    on: {
      "command": function (event) {
        return _vm.$emit('bulk-action-event', event);
      }
    }
  }, [_c('el-button', {
    staticClass: "px-2 font-medium",
    staticStyle: {
      "background-color": "#E6EEF6"
    },
    attrs: {
      "type": "text",
      "size": _vm.size
    }
  }, [_vm._v("\n              " + _vm._s(_vm.bulkActionsMenuTitle)), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right",
    staticStyle: {
      "font-size": "12px"
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', _vm._l(_vm.bulkMenuActions, function (item, index) {
    return _c('el-dropdown-item', {
      key: index,
      staticClass: "cursor-pointer el-dropdown-item",
      attrs: {
        "command": item.title,
        "disabled": item.disabled
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")]);
  }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.tableActions && _vm.tableActions.length > 0 ? _c('el-dropdown', {
    staticClass: "mr-4",
    attrs: {
      "trigger": "click",
      "type": "primary"
    },
    on: {
      "command": function ($event) {
        return _vm.$emit('table-action', $event);
      }
    }
  }, [_c('el-button', {
    staticClass: "px-2 font-medium table-actions-button",
    attrs: {
      "type": "text",
      "size": _vm.size
    }
  }, [_vm._v("\n            Table Actions"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.tableActions, function (action, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "command": action
      }
    }, [_vm._v(_vm._s(action))]);
  }), 1)], 1) : _vm._e(), _vm._v(" "), _vm.expandDataNode ? _c('p', {
    staticClass: "cursor-pointer text-xs mr-4 block",
    staticStyle: {
      "color": "#0f5975"
    },
    on: {
      "click": _vm.toggleExpandAllNodes
    }
  }, [_vm._v("\n          " + _vm._s(_vm.toggleExpandNodeText) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('table-status', {
    staticClass: "mr-4"
  }), _vm._v(" "), _c('el-popover', {
    attrs: {
      "title": "Table Columns",
      "width": "300",
      "placement": "bottom-end",
      "trigger": "click"
    }
  }, [_vm.alwaysShowTableOptions ? _c('table-options', {
    staticClass: "table-options"
  }) : _vm._e(), _vm._v(" "), _vm.alwaysShowColumnsSection ? _c('el-button', {
    staticClass: "flex-grow",
    attrs: {
      "slot": "reference",
      "type": "text"
    },
    slot: "reference"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', 'columns']
    }
  })], 1) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', [_vm._t("default", function () {
    return [[_vm.tableHasData ? _c('table-wrapper', {
      key: _vm.tableKey,
      attrs: {
        "stripe": _vm.stripe,
        "fetchingData": _vm.loading,
        "expandDataNode": _vm.expandDataNode,
        "operationsComponent": _vm.operationsComponent,
        "rowClassNameFn": _vm.rowClassNameFn,
        "rowSelectableFn": _vm.rowSelectableFn,
        "showSelectable": _vm.showSelectable,
        "tableRowActions": _vm.tableRowActions,
        "defaultExpandAll": _vm.defaultExpandAll,
        "rowKey": _vm.rowKey,
        "reserveSelection": _vm.reserveSelection
      },
      on: {
        "emitEvent": _vm.onEmitEvent,
        "selection-change": _vm.selectionChangeHandler,
        "tableRowDbClicked": _vm.emitTableRowDbClicked,
        "tableRowClicked": _vm.tableRowClickedHandler,
        "sort-change": _vm.changeSort,
        "table-row-action": function ($event) {
          return _vm.$emit('table-row-action', $event);
        }
      }
    }) : !_vm.tableHasData && !_vm.loading ? _vm._t("notFound", function () {
      return [_c('span', {
        staticClass: "text-gray-500 text-center w-full block text-2xl"
      }, [_vm._v("No Results")])];
    }) : _vm._e()]];
  }, {
    "customCompData": _vm.data,
    "stripe": _vm.stripe,
    "fetchingData": _vm.loading,
    "expandDataNode": _vm.expandDataNode,
    "operationsComponent": _vm.operationsComponent,
    "rowClassNameFn": _vm.rowClassNameFn,
    "rowSelectableFn": _vm.rowSelectableFn,
    "showSelectable": _vm.showSelectable,
    "tableRowActions": _vm.tableRowActions,
    "defaultExpandAll": _vm.defaultExpandAll,
    "emitEvent": _vm.onEmitEvent,
    "selectionChange": _vm.selectionChangeHandler,
    "tableRowDbClicked": _vm.emitTableRowDbClicked,
    "tableRowClicked": _vm.tableRowClickedHandler,
    "sortChange": _vm.changeSort,
    "tableRowAction": function (event) {
      return _vm.$emit('table-row-action', event);
    }
  })], 2), _vm._v(" "), !_vm.loading && _vm.showPagination && _vm.totalRecords ? _c('div', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('pagination', {
    attrs: {
      "pagerCount": _vm.viewWindowSize === 'sm' ? 3 : 5
    }
  }), _vm._v(" "), _vm.canShowAll && !_vm.showingAllRecords ? _c('IAButton', {
    staticClass: "ml-4 text-xs",
    attrs: {
      "title": 'Show All',
      "click": _vm.showAllHandler,
      "type": "text"
    }
  }) : _vm._e()], 1)]) : _vm._e()])], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-1f28eba0_0", {
    source: ".el-dropdown-item[data-v-1f28eba0]:hover{--text-opacity:1!important;color:#a0aec0!important;color:rgba(160,174,192,var(--text-opacity))!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-1f28eba0";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

var ListView = __vue_component__;

function install$1(Vue, options) {
  options.store.registerModule("list_view_module", list_view_module);
  Vue.component(options.searchBarName || "INFListViewSearchBar", ListViewSearchBar);
  Vue.component(options.name || "INFListView", ListView);
  Vue.use(options.router);
}

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    install: install$1
});

locale.use(lang); // install function executed by Vue.use()

const install = function installInfVueComponents(Vue) {
  Object.entries(components).forEach(_ref => {
    let [componentName, component] = _ref;
    Vue.component(componentName, component);
  });
}; // Create module definition for Vue.use()

export { index$1 as GetText, __vue_component__$y as INFAuthCodeInput, INFButton, __vue_component__$A as INFContentCard, __vue_component__$n as INFCurrencyFormatter, __vue_component__$t as INFCurrencyInput, __vue_component__$G as INFCustomDatePicker, INFDatePicker, __vue_component__$v as INFDateTimePicker, index$2 as INFFilters, __vue_component__$l as INFGetText, __vue_component__$j as INFHTMLContent, __vue_component__$p as INFImage, index as INFListView, __vue_component__$C as INFPageButton, __vue_component__$E as INFPageMessage, INFSelectField, __vue_component__$r as INFTaxIdField, INFTextField, install as default };
